/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const pricestream = $root.pricestream = (() => {

    /**
     * Namespace pricestream.
     * @exports pricestream
     * @namespace
     */
    const pricestream = {};

    pricestream.PriceStreamMessage = (function() {

        /**
         * Properties of a PriceStreamMessage.
         * @memberof pricestream
         * @interface IPriceStreamMessage
         * @property {pricestream.IOrderUpdate|null} [orderUpdate] PriceStreamMessage orderUpdate
         * @property {pricestream.IGameUpdate|null} [gameUpdate] PriceStreamMessage gameUpdate
         * @property {pricestream.IMatchedVolumeUpdate|null} [matchedVolumeUpdate] PriceStreamMessage matchedVolumeUpdate
         * @property {pricestream.IUserOrderKeyUpdate|null} [userOrderKeyUpdate] PriceStreamMessage userOrderKeyUpdate
         */

        /**
         * Constructs a new PriceStreamMessage.
         * @memberof pricestream
         * @classdesc Represents a PriceStreamMessage.
         * @implements IPriceStreamMessage
         * @constructor
         * @param {pricestream.IPriceStreamMessage=} [properties] Properties to set
         */
        function PriceStreamMessage(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PriceStreamMessage orderUpdate.
         * @member {pricestream.IOrderUpdate|null|undefined} orderUpdate
         * @memberof pricestream.PriceStreamMessage
         * @instance
         */
        PriceStreamMessage.prototype.orderUpdate = null;

        /**
         * PriceStreamMessage gameUpdate.
         * @member {pricestream.IGameUpdate|null|undefined} gameUpdate
         * @memberof pricestream.PriceStreamMessage
         * @instance
         */
        PriceStreamMessage.prototype.gameUpdate = null;

        /**
         * PriceStreamMessage matchedVolumeUpdate.
         * @member {pricestream.IMatchedVolumeUpdate|null|undefined} matchedVolumeUpdate
         * @memberof pricestream.PriceStreamMessage
         * @instance
         */
        PriceStreamMessage.prototype.matchedVolumeUpdate = null;

        /**
         * PriceStreamMessage userOrderKeyUpdate.
         * @member {pricestream.IUserOrderKeyUpdate|null|undefined} userOrderKeyUpdate
         * @memberof pricestream.PriceStreamMessage
         * @instance
         */
        PriceStreamMessage.prototype.userOrderKeyUpdate = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * PriceStreamMessage message.
         * @member {"orderUpdate"|"gameUpdate"|"matchedVolumeUpdate"|"userOrderKeyUpdate"|undefined} message
         * @memberof pricestream.PriceStreamMessage
         * @instance
         */
        Object.defineProperty(PriceStreamMessage.prototype, "message", {
            get: $util.oneOfGetter($oneOfFields = ["orderUpdate", "gameUpdate", "matchedVolumeUpdate", "userOrderKeyUpdate"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new PriceStreamMessage instance using the specified properties.
         * @function create
         * @memberof pricestream.PriceStreamMessage
         * @static
         * @param {pricestream.IPriceStreamMessage=} [properties] Properties to set
         * @returns {pricestream.PriceStreamMessage} PriceStreamMessage instance
         */
        PriceStreamMessage.create = function create(properties) {
            return new PriceStreamMessage(properties);
        };

        /**
         * Encodes the specified PriceStreamMessage message. Does not implicitly {@link pricestream.PriceStreamMessage.verify|verify} messages.
         * @function encode
         * @memberof pricestream.PriceStreamMessage
         * @static
         * @param {pricestream.IPriceStreamMessage} message PriceStreamMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PriceStreamMessage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.orderUpdate != null && Object.hasOwnProperty.call(message, "orderUpdate"))
                $root.pricestream.OrderUpdate.encode(message.orderUpdate, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.gameUpdate != null && Object.hasOwnProperty.call(message, "gameUpdate"))
                $root.pricestream.GameUpdate.encode(message.gameUpdate, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.matchedVolumeUpdate != null && Object.hasOwnProperty.call(message, "matchedVolumeUpdate"))
                $root.pricestream.MatchedVolumeUpdate.encode(message.matchedVolumeUpdate, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.userOrderKeyUpdate != null && Object.hasOwnProperty.call(message, "userOrderKeyUpdate"))
                $root.pricestream.UserOrderKeyUpdate.encode(message.userOrderKeyUpdate, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified PriceStreamMessage message, length delimited. Does not implicitly {@link pricestream.PriceStreamMessage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof pricestream.PriceStreamMessage
         * @static
         * @param {pricestream.IPriceStreamMessage} message PriceStreamMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PriceStreamMessage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PriceStreamMessage message from the specified reader or buffer.
         * @function decode
         * @memberof pricestream.PriceStreamMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {pricestream.PriceStreamMessage} PriceStreamMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PriceStreamMessage.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.pricestream.PriceStreamMessage();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.orderUpdate = $root.pricestream.OrderUpdate.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.gameUpdate = $root.pricestream.GameUpdate.decode(reader, reader.uint32());
                        break;
                    }
                case 3: {
                        message.matchedVolumeUpdate = $root.pricestream.MatchedVolumeUpdate.decode(reader, reader.uint32());
                        break;
                    }
                case 4: {
                        message.userOrderKeyUpdate = $root.pricestream.UserOrderKeyUpdate.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PriceStreamMessage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof pricestream.PriceStreamMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {pricestream.PriceStreamMessage} PriceStreamMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PriceStreamMessage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PriceStreamMessage message.
         * @function verify
         * @memberof pricestream.PriceStreamMessage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PriceStreamMessage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.orderUpdate != null && message.hasOwnProperty("orderUpdate")) {
                properties.message = 1;
                {
                    let error = $root.pricestream.OrderUpdate.verify(message.orderUpdate);
                    if (error)
                        return "orderUpdate." + error;
                }
            }
            if (message.gameUpdate != null && message.hasOwnProperty("gameUpdate")) {
                if (properties.message === 1)
                    return "message: multiple values";
                properties.message = 1;
                {
                    let error = $root.pricestream.GameUpdate.verify(message.gameUpdate);
                    if (error)
                        return "gameUpdate." + error;
                }
            }
            if (message.matchedVolumeUpdate != null && message.hasOwnProperty("matchedVolumeUpdate")) {
                if (properties.message === 1)
                    return "message: multiple values";
                properties.message = 1;
                {
                    let error = $root.pricestream.MatchedVolumeUpdate.verify(message.matchedVolumeUpdate);
                    if (error)
                        return "matchedVolumeUpdate." + error;
                }
            }
            if (message.userOrderKeyUpdate != null && message.hasOwnProperty("userOrderKeyUpdate")) {
                if (properties.message === 1)
                    return "message: multiple values";
                properties.message = 1;
                {
                    let error = $root.pricestream.UserOrderKeyUpdate.verify(message.userOrderKeyUpdate);
                    if (error)
                        return "userOrderKeyUpdate." + error;
                }
            }
            return null;
        };

        /**
         * Creates a PriceStreamMessage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pricestream.PriceStreamMessage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pricestream.PriceStreamMessage} PriceStreamMessage
         */
        PriceStreamMessage.fromObject = function fromObject(object) {
            if (object instanceof $root.pricestream.PriceStreamMessage)
                return object;
            let message = new $root.pricestream.PriceStreamMessage();
            if (object.orderUpdate != null) {
                if (typeof object.orderUpdate !== "object")
                    throw TypeError(".pricestream.PriceStreamMessage.orderUpdate: object expected");
                message.orderUpdate = $root.pricestream.OrderUpdate.fromObject(object.orderUpdate);
            }
            if (object.gameUpdate != null) {
                if (typeof object.gameUpdate !== "object")
                    throw TypeError(".pricestream.PriceStreamMessage.gameUpdate: object expected");
                message.gameUpdate = $root.pricestream.GameUpdate.fromObject(object.gameUpdate);
            }
            if (object.matchedVolumeUpdate != null) {
                if (typeof object.matchedVolumeUpdate !== "object")
                    throw TypeError(".pricestream.PriceStreamMessage.matchedVolumeUpdate: object expected");
                message.matchedVolumeUpdate = $root.pricestream.MatchedVolumeUpdate.fromObject(object.matchedVolumeUpdate);
            }
            if (object.userOrderKeyUpdate != null) {
                if (typeof object.userOrderKeyUpdate !== "object")
                    throw TypeError(".pricestream.PriceStreamMessage.userOrderKeyUpdate: object expected");
                message.userOrderKeyUpdate = $root.pricestream.UserOrderKeyUpdate.fromObject(object.userOrderKeyUpdate);
            }
            return message;
        };

        /**
         * Creates a plain object from a PriceStreamMessage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pricestream.PriceStreamMessage
         * @static
         * @param {pricestream.PriceStreamMessage} message PriceStreamMessage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PriceStreamMessage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.orderUpdate != null && message.hasOwnProperty("orderUpdate")) {
                object.orderUpdate = $root.pricestream.OrderUpdate.toObject(message.orderUpdate, options);
                if (options.oneofs)
                    object.message = "orderUpdate";
            }
            if (message.gameUpdate != null && message.hasOwnProperty("gameUpdate")) {
                object.gameUpdate = $root.pricestream.GameUpdate.toObject(message.gameUpdate, options);
                if (options.oneofs)
                    object.message = "gameUpdate";
            }
            if (message.matchedVolumeUpdate != null && message.hasOwnProperty("matchedVolumeUpdate")) {
                object.matchedVolumeUpdate = $root.pricestream.MatchedVolumeUpdate.toObject(message.matchedVolumeUpdate, options);
                if (options.oneofs)
                    object.message = "matchedVolumeUpdate";
            }
            if (message.userOrderKeyUpdate != null && message.hasOwnProperty("userOrderKeyUpdate")) {
                object.userOrderKeyUpdate = $root.pricestream.UserOrderKeyUpdate.toObject(message.userOrderKeyUpdate, options);
                if (options.oneofs)
                    object.message = "userOrderKeyUpdate";
            }
            return object;
        };

        /**
         * Converts this PriceStreamMessage to JSON.
         * @function toJSON
         * @memberof pricestream.PriceStreamMessage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PriceStreamMessage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PriceStreamMessage
         * @function getTypeUrl
         * @memberof pricestream.PriceStreamMessage
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PriceStreamMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/pricestream.PriceStreamMessage";
        };

        return PriceStreamMessage;
    })();

    pricestream.UserOrderKeyUpdate = (function() {

        /**
         * Properties of a UserOrderKeyUpdate.
         * @memberof pricestream
         * @interface IUserOrderKeyUpdate
         * @property {Array.<pricestream.IUserOrderKey>|null} [keys] UserOrderKeyUpdate keys
         */

        /**
         * Constructs a new UserOrderKeyUpdate.
         * @memberof pricestream
         * @classdesc Represents a UserOrderKeyUpdate.
         * @implements IUserOrderKeyUpdate
         * @constructor
         * @param {pricestream.IUserOrderKeyUpdate=} [properties] Properties to set
         */
        function UserOrderKeyUpdate(properties) {
            this.keys = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UserOrderKeyUpdate keys.
         * @member {Array.<pricestream.IUserOrderKey>} keys
         * @memberof pricestream.UserOrderKeyUpdate
         * @instance
         */
        UserOrderKeyUpdate.prototype.keys = $util.emptyArray;

        /**
         * Creates a new UserOrderKeyUpdate instance using the specified properties.
         * @function create
         * @memberof pricestream.UserOrderKeyUpdate
         * @static
         * @param {pricestream.IUserOrderKeyUpdate=} [properties] Properties to set
         * @returns {pricestream.UserOrderKeyUpdate} UserOrderKeyUpdate instance
         */
        UserOrderKeyUpdate.create = function create(properties) {
            return new UserOrderKeyUpdate(properties);
        };

        /**
         * Encodes the specified UserOrderKeyUpdate message. Does not implicitly {@link pricestream.UserOrderKeyUpdate.verify|verify} messages.
         * @function encode
         * @memberof pricestream.UserOrderKeyUpdate
         * @static
         * @param {pricestream.IUserOrderKeyUpdate} message UserOrderKeyUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserOrderKeyUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.keys != null && message.keys.length)
                for (let i = 0; i < message.keys.length; ++i)
                    $root.pricestream.UserOrderKey.encode(message.keys[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified UserOrderKeyUpdate message, length delimited. Does not implicitly {@link pricestream.UserOrderKeyUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof pricestream.UserOrderKeyUpdate
         * @static
         * @param {pricestream.IUserOrderKeyUpdate} message UserOrderKeyUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserOrderKeyUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a UserOrderKeyUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof pricestream.UserOrderKeyUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {pricestream.UserOrderKeyUpdate} UserOrderKeyUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserOrderKeyUpdate.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.pricestream.UserOrderKeyUpdate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.keys && message.keys.length))
                            message.keys = [];
                        message.keys.push($root.pricestream.UserOrderKey.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a UserOrderKeyUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof pricestream.UserOrderKeyUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {pricestream.UserOrderKeyUpdate} UserOrderKeyUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserOrderKeyUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a UserOrderKeyUpdate message.
         * @function verify
         * @memberof pricestream.UserOrderKeyUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UserOrderKeyUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.keys != null && message.hasOwnProperty("keys")) {
                if (!Array.isArray(message.keys))
                    return "keys: array expected";
                for (let i = 0; i < message.keys.length; ++i) {
                    let error = $root.pricestream.UserOrderKey.verify(message.keys[i]);
                    if (error)
                        return "keys." + error;
                }
            }
            return null;
        };

        /**
         * Creates a UserOrderKeyUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pricestream.UserOrderKeyUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pricestream.UserOrderKeyUpdate} UserOrderKeyUpdate
         */
        UserOrderKeyUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.pricestream.UserOrderKeyUpdate)
                return object;
            let message = new $root.pricestream.UserOrderKeyUpdate();
            if (object.keys) {
                if (!Array.isArray(object.keys))
                    throw TypeError(".pricestream.UserOrderKeyUpdate.keys: array expected");
                message.keys = [];
                for (let i = 0; i < object.keys.length; ++i) {
                    if (typeof object.keys[i] !== "object")
                        throw TypeError(".pricestream.UserOrderKeyUpdate.keys: object expected");
                    message.keys[i] = $root.pricestream.UserOrderKey.fromObject(object.keys[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a UserOrderKeyUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pricestream.UserOrderKeyUpdate
         * @static
         * @param {pricestream.UserOrderKeyUpdate} message UserOrderKeyUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserOrderKeyUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.keys = [];
            if (message.keys && message.keys.length) {
                object.keys = [];
                for (let j = 0; j < message.keys.length; ++j)
                    object.keys[j] = $root.pricestream.UserOrderKey.toObject(message.keys[j], options);
            }
            return object;
        };

        /**
         * Converts this UserOrderKeyUpdate to JSON.
         * @function toJSON
         * @memberof pricestream.UserOrderKeyUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserOrderKeyUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UserOrderKeyUpdate
         * @function getTypeUrl
         * @memberof pricestream.UserOrderKeyUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UserOrderKeyUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/pricestream.UserOrderKeyUpdate";
        };

        return UserOrderKeyUpdate;
    })();

    pricestream.OrderUpdate = (function() {

        /**
         * Properties of an OrderUpdate.
         * @memberof pricestream
         * @interface IOrderUpdate
         * @property {string|null} [gameId] OrderUpdate gameId
         * @property {string|null} [sport] OrderUpdate sport
         * @property {string|null} [league] OrderUpdate league
         * @property {boolean|null} [live] OrderUpdate live
         * @property {string|null} [type] OrderUpdate type
         * @property {string|null} [participantId] OrderUpdate participantId
         * @property {string|null} [market] OrderUpdate market
         * @property {string|null} [side] OrderUpdate side
         * @property {string|null} [ou] OrderUpdate ou
         * @property {number|null} [total] OrderUpdate total
         * @property {number|null} [spread] OrderUpdate spread
         * @property {number|null} [mainHomeSpread] OrderUpdate mainHomeSpread
         * @property {number|null} [mainAwaySpread] OrderUpdate mainAwaySpread
         * @property {number|null} [mainTotal] OrderUpdate mainTotal
         * @property {Array.<pricestream.ISideOrder>|null} [sideOrders] OrderUpdate sideOrders
         * @property {number|null} [epoch] OrderUpdate epoch
         * @property {string|null} [triggerOrderId] OrderUpdate triggerOrderId
         */

        /**
         * Constructs a new OrderUpdate.
         * @memberof pricestream
         * @classdesc Represents an OrderUpdate.
         * @implements IOrderUpdate
         * @constructor
         * @param {pricestream.IOrderUpdate=} [properties] Properties to set
         */
        function OrderUpdate(properties) {
            this.sideOrders = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OrderUpdate gameId.
         * @member {string} gameId
         * @memberof pricestream.OrderUpdate
         * @instance
         */
        OrderUpdate.prototype.gameId = "";

        /**
         * OrderUpdate sport.
         * @member {string} sport
         * @memberof pricestream.OrderUpdate
         * @instance
         */
        OrderUpdate.prototype.sport = "";

        /**
         * OrderUpdate league.
         * @member {string} league
         * @memberof pricestream.OrderUpdate
         * @instance
         */
        OrderUpdate.prototype.league = "";

        /**
         * OrderUpdate live.
         * @member {boolean} live
         * @memberof pricestream.OrderUpdate
         * @instance
         */
        OrderUpdate.prototype.live = false;

        /**
         * OrderUpdate type.
         * @member {string} type
         * @memberof pricestream.OrderUpdate
         * @instance
         */
        OrderUpdate.prototype.type = "";

        /**
         * OrderUpdate participantId.
         * @member {string} participantId
         * @memberof pricestream.OrderUpdate
         * @instance
         */
        OrderUpdate.prototype.participantId = "";

        /**
         * OrderUpdate market.
         * @member {string} market
         * @memberof pricestream.OrderUpdate
         * @instance
         */
        OrderUpdate.prototype.market = "";

        /**
         * OrderUpdate side.
         * @member {string} side
         * @memberof pricestream.OrderUpdate
         * @instance
         */
        OrderUpdate.prototype.side = "";

        /**
         * OrderUpdate ou.
         * @member {string} ou
         * @memberof pricestream.OrderUpdate
         * @instance
         */
        OrderUpdate.prototype.ou = "";

        /**
         * OrderUpdate total.
         * @member {number|null|undefined} total
         * @memberof pricestream.OrderUpdate
         * @instance
         */
        OrderUpdate.prototype.total = null;

        /**
         * OrderUpdate spread.
         * @member {number|null|undefined} spread
         * @memberof pricestream.OrderUpdate
         * @instance
         */
        OrderUpdate.prototype.spread = null;

        /**
         * OrderUpdate mainHomeSpread.
         * @member {number|null|undefined} mainHomeSpread
         * @memberof pricestream.OrderUpdate
         * @instance
         */
        OrderUpdate.prototype.mainHomeSpread = null;

        /**
         * OrderUpdate mainAwaySpread.
         * @member {number|null|undefined} mainAwaySpread
         * @memberof pricestream.OrderUpdate
         * @instance
         */
        OrderUpdate.prototype.mainAwaySpread = null;

        /**
         * OrderUpdate mainTotal.
         * @member {number|null|undefined} mainTotal
         * @memberof pricestream.OrderUpdate
         * @instance
         */
        OrderUpdate.prototype.mainTotal = null;

        /**
         * OrderUpdate sideOrders.
         * @member {Array.<pricestream.ISideOrder>} sideOrders
         * @memberof pricestream.OrderUpdate
         * @instance
         */
        OrderUpdate.prototype.sideOrders = $util.emptyArray;

        /**
         * OrderUpdate epoch.
         * @member {number} epoch
         * @memberof pricestream.OrderUpdate
         * @instance
         */
        OrderUpdate.prototype.epoch = 0;

        /**
         * OrderUpdate triggerOrderId.
         * @member {string|null|undefined} triggerOrderId
         * @memberof pricestream.OrderUpdate
         * @instance
         */
        OrderUpdate.prototype.triggerOrderId = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(OrderUpdate.prototype, "_total", {
            get: $util.oneOfGetter($oneOfFields = ["total"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(OrderUpdate.prototype, "_spread", {
            get: $util.oneOfGetter($oneOfFields = ["spread"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(OrderUpdate.prototype, "_mainHomeSpread", {
            get: $util.oneOfGetter($oneOfFields = ["mainHomeSpread"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(OrderUpdate.prototype, "_mainAwaySpread", {
            get: $util.oneOfGetter($oneOfFields = ["mainAwaySpread"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(OrderUpdate.prototype, "_mainTotal", {
            get: $util.oneOfGetter($oneOfFields = ["mainTotal"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(OrderUpdate.prototype, "_triggerOrderId", {
            get: $util.oneOfGetter($oneOfFields = ["triggerOrderId"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new OrderUpdate instance using the specified properties.
         * @function create
         * @memberof pricestream.OrderUpdate
         * @static
         * @param {pricestream.IOrderUpdate=} [properties] Properties to set
         * @returns {pricestream.OrderUpdate} OrderUpdate instance
         */
        OrderUpdate.create = function create(properties) {
            return new OrderUpdate(properties);
        };

        /**
         * Encodes the specified OrderUpdate message. Does not implicitly {@link pricestream.OrderUpdate.verify|verify} messages.
         * @function encode
         * @memberof pricestream.OrderUpdate
         * @static
         * @param {pricestream.IOrderUpdate} message OrderUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OrderUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.gameId != null && Object.hasOwnProperty.call(message, "gameId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.gameId);
            if (message.sport != null && Object.hasOwnProperty.call(message, "sport"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.sport);
            if (message.league != null && Object.hasOwnProperty.call(message, "league"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.league);
            if (message.live != null && Object.hasOwnProperty.call(message, "live"))
                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.live);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.type);
            if (message.participantId != null && Object.hasOwnProperty.call(message, "participantId"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.participantId);
            if (message.market != null && Object.hasOwnProperty.call(message, "market"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.market);
            if (message.side != null && Object.hasOwnProperty.call(message, "side"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.side);
            if (message.ou != null && Object.hasOwnProperty.call(message, "ou"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.ou);
            if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                writer.uint32(/* id 10, wireType 1 =*/81).double(message.total);
            if (message.spread != null && Object.hasOwnProperty.call(message, "spread"))
                writer.uint32(/* id 11, wireType 1 =*/89).double(message.spread);
            if (message.mainHomeSpread != null && Object.hasOwnProperty.call(message, "mainHomeSpread"))
                writer.uint32(/* id 12, wireType 1 =*/97).double(message.mainHomeSpread);
            if (message.mainAwaySpread != null && Object.hasOwnProperty.call(message, "mainAwaySpread"))
                writer.uint32(/* id 13, wireType 1 =*/105).double(message.mainAwaySpread);
            if (message.mainTotal != null && Object.hasOwnProperty.call(message, "mainTotal"))
                writer.uint32(/* id 14, wireType 1 =*/113).double(message.mainTotal);
            if (message.sideOrders != null && message.sideOrders.length)
                for (let i = 0; i < message.sideOrders.length; ++i)
                    $root.pricestream.SideOrder.encode(message.sideOrders[i], writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
            if (message.epoch != null && Object.hasOwnProperty.call(message, "epoch"))
                writer.uint32(/* id 16, wireType 0 =*/128).uint32(message.epoch);
            if (message.triggerOrderId != null && Object.hasOwnProperty.call(message, "triggerOrderId"))
                writer.uint32(/* id 17, wireType 2 =*/138).string(message.triggerOrderId);
            return writer;
        };

        /**
         * Encodes the specified OrderUpdate message, length delimited. Does not implicitly {@link pricestream.OrderUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof pricestream.OrderUpdate
         * @static
         * @param {pricestream.IOrderUpdate} message OrderUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OrderUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OrderUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof pricestream.OrderUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {pricestream.OrderUpdate} OrderUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OrderUpdate.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.pricestream.OrderUpdate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.gameId = reader.string();
                        break;
                    }
                case 2: {
                        message.sport = reader.string();
                        break;
                    }
                case 3: {
                        message.league = reader.string();
                        break;
                    }
                case 4: {
                        message.live = reader.bool();
                        break;
                    }
                case 5: {
                        message.type = reader.string();
                        break;
                    }
                case 6: {
                        message.participantId = reader.string();
                        break;
                    }
                case 7: {
                        message.market = reader.string();
                        break;
                    }
                case 8: {
                        message.side = reader.string();
                        break;
                    }
                case 9: {
                        message.ou = reader.string();
                        break;
                    }
                case 10: {
                        message.total = reader.double();
                        break;
                    }
                case 11: {
                        message.spread = reader.double();
                        break;
                    }
                case 12: {
                        message.mainHomeSpread = reader.double();
                        break;
                    }
                case 13: {
                        message.mainAwaySpread = reader.double();
                        break;
                    }
                case 14: {
                        message.mainTotal = reader.double();
                        break;
                    }
                case 15: {
                        if (!(message.sideOrders && message.sideOrders.length))
                            message.sideOrders = [];
                        message.sideOrders.push($root.pricestream.SideOrder.decode(reader, reader.uint32()));
                        break;
                    }
                case 16: {
                        message.epoch = reader.uint32();
                        break;
                    }
                case 17: {
                        message.triggerOrderId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OrderUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof pricestream.OrderUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {pricestream.OrderUpdate} OrderUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OrderUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OrderUpdate message.
         * @function verify
         * @memberof pricestream.OrderUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OrderUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.gameId != null && message.hasOwnProperty("gameId"))
                if (!$util.isString(message.gameId))
                    return "gameId: string expected";
            if (message.sport != null && message.hasOwnProperty("sport"))
                if (!$util.isString(message.sport))
                    return "sport: string expected";
            if (message.league != null && message.hasOwnProperty("league"))
                if (!$util.isString(message.league))
                    return "league: string expected";
            if (message.live != null && message.hasOwnProperty("live"))
                if (typeof message.live !== "boolean")
                    return "live: boolean expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isString(message.type))
                    return "type: string expected";
            if (message.participantId != null && message.hasOwnProperty("participantId"))
                if (!$util.isString(message.participantId))
                    return "participantId: string expected";
            if (message.market != null && message.hasOwnProperty("market"))
                if (!$util.isString(message.market))
                    return "market: string expected";
            if (message.side != null && message.hasOwnProperty("side"))
                if (!$util.isString(message.side))
                    return "side: string expected";
            if (message.ou != null && message.hasOwnProperty("ou"))
                if (!$util.isString(message.ou))
                    return "ou: string expected";
            if (message.total != null && message.hasOwnProperty("total")) {
                properties._total = 1;
                if (typeof message.total !== "number")
                    return "total: number expected";
            }
            if (message.spread != null && message.hasOwnProperty("spread")) {
                properties._spread = 1;
                if (typeof message.spread !== "number")
                    return "spread: number expected";
            }
            if (message.mainHomeSpread != null && message.hasOwnProperty("mainHomeSpread")) {
                properties._mainHomeSpread = 1;
                if (typeof message.mainHomeSpread !== "number")
                    return "mainHomeSpread: number expected";
            }
            if (message.mainAwaySpread != null && message.hasOwnProperty("mainAwaySpread")) {
                properties._mainAwaySpread = 1;
                if (typeof message.mainAwaySpread !== "number")
                    return "mainAwaySpread: number expected";
            }
            if (message.mainTotal != null && message.hasOwnProperty("mainTotal")) {
                properties._mainTotal = 1;
                if (typeof message.mainTotal !== "number")
                    return "mainTotal: number expected";
            }
            if (message.sideOrders != null && message.hasOwnProperty("sideOrders")) {
                if (!Array.isArray(message.sideOrders))
                    return "sideOrders: array expected";
                for (let i = 0; i < message.sideOrders.length; ++i) {
                    let error = $root.pricestream.SideOrder.verify(message.sideOrders[i]);
                    if (error)
                        return "sideOrders." + error;
                }
            }
            if (message.epoch != null && message.hasOwnProperty("epoch"))
                if (!$util.isInteger(message.epoch))
                    return "epoch: integer expected";
            if (message.triggerOrderId != null && message.hasOwnProperty("triggerOrderId")) {
                properties._triggerOrderId = 1;
                if (!$util.isString(message.triggerOrderId))
                    return "triggerOrderId: string expected";
            }
            return null;
        };

        /**
         * Creates an OrderUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pricestream.OrderUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pricestream.OrderUpdate} OrderUpdate
         */
        OrderUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.pricestream.OrderUpdate)
                return object;
            let message = new $root.pricestream.OrderUpdate();
            if (object.gameId != null)
                message.gameId = String(object.gameId);
            if (object.sport != null)
                message.sport = String(object.sport);
            if (object.league != null)
                message.league = String(object.league);
            if (object.live != null)
                message.live = Boolean(object.live);
            if (object.type != null)
                message.type = String(object.type);
            if (object.participantId != null)
                message.participantId = String(object.participantId);
            if (object.market != null)
                message.market = String(object.market);
            if (object.side != null)
                message.side = String(object.side);
            if (object.ou != null)
                message.ou = String(object.ou);
            if (object.total != null)
                message.total = Number(object.total);
            if (object.spread != null)
                message.spread = Number(object.spread);
            if (object.mainHomeSpread != null)
                message.mainHomeSpread = Number(object.mainHomeSpread);
            if (object.mainAwaySpread != null)
                message.mainAwaySpread = Number(object.mainAwaySpread);
            if (object.mainTotal != null)
                message.mainTotal = Number(object.mainTotal);
            if (object.sideOrders) {
                if (!Array.isArray(object.sideOrders))
                    throw TypeError(".pricestream.OrderUpdate.sideOrders: array expected");
                message.sideOrders = [];
                for (let i = 0; i < object.sideOrders.length; ++i) {
                    if (typeof object.sideOrders[i] !== "object")
                        throw TypeError(".pricestream.OrderUpdate.sideOrders: object expected");
                    message.sideOrders[i] = $root.pricestream.SideOrder.fromObject(object.sideOrders[i]);
                }
            }
            if (object.epoch != null)
                message.epoch = object.epoch >>> 0;
            if (object.triggerOrderId != null)
                message.triggerOrderId = String(object.triggerOrderId);
            return message;
        };

        /**
         * Creates a plain object from an OrderUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pricestream.OrderUpdate
         * @static
         * @param {pricestream.OrderUpdate} message OrderUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OrderUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.sideOrders = [];
            if (options.defaults) {
                object.gameId = "";
                object.sport = "";
                object.league = "";
                object.live = false;
                object.type = "";
                object.participantId = "";
                object.market = "";
                object.side = "";
                object.ou = "";
                object.epoch = 0;
            }
            if (message.gameId != null && message.hasOwnProperty("gameId"))
                object.gameId = message.gameId;
            if (message.sport != null && message.hasOwnProperty("sport"))
                object.sport = message.sport;
            if (message.league != null && message.hasOwnProperty("league"))
                object.league = message.league;
            if (message.live != null && message.hasOwnProperty("live"))
                object.live = message.live;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.participantId != null && message.hasOwnProperty("participantId"))
                object.participantId = message.participantId;
            if (message.market != null && message.hasOwnProperty("market"))
                object.market = message.market;
            if (message.side != null && message.hasOwnProperty("side"))
                object.side = message.side;
            if (message.ou != null && message.hasOwnProperty("ou"))
                object.ou = message.ou;
            if (message.total != null && message.hasOwnProperty("total")) {
                object.total = options.json && !isFinite(message.total) ? String(message.total) : message.total;
                if (options.oneofs)
                    object._total = "total";
            }
            if (message.spread != null && message.hasOwnProperty("spread")) {
                object.spread = options.json && !isFinite(message.spread) ? String(message.spread) : message.spread;
                if (options.oneofs)
                    object._spread = "spread";
            }
            if (message.mainHomeSpread != null && message.hasOwnProperty("mainHomeSpread")) {
                object.mainHomeSpread = options.json && !isFinite(message.mainHomeSpread) ? String(message.mainHomeSpread) : message.mainHomeSpread;
                if (options.oneofs)
                    object._mainHomeSpread = "mainHomeSpread";
            }
            if (message.mainAwaySpread != null && message.hasOwnProperty("mainAwaySpread")) {
                object.mainAwaySpread = options.json && !isFinite(message.mainAwaySpread) ? String(message.mainAwaySpread) : message.mainAwaySpread;
                if (options.oneofs)
                    object._mainAwaySpread = "mainAwaySpread";
            }
            if (message.mainTotal != null && message.hasOwnProperty("mainTotal")) {
                object.mainTotal = options.json && !isFinite(message.mainTotal) ? String(message.mainTotal) : message.mainTotal;
                if (options.oneofs)
                    object._mainTotal = "mainTotal";
            }
            if (message.sideOrders && message.sideOrders.length) {
                object.sideOrders = [];
                for (let j = 0; j < message.sideOrders.length; ++j)
                    object.sideOrders[j] = $root.pricestream.SideOrder.toObject(message.sideOrders[j], options);
            }
            if (message.epoch != null && message.hasOwnProperty("epoch"))
                object.epoch = message.epoch;
            if (message.triggerOrderId != null && message.hasOwnProperty("triggerOrderId")) {
                object.triggerOrderId = message.triggerOrderId;
                if (options.oneofs)
                    object._triggerOrderId = "triggerOrderId";
            }
            return object;
        };

        /**
         * Converts this OrderUpdate to JSON.
         * @function toJSON
         * @memberof pricestream.OrderUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OrderUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for OrderUpdate
         * @function getTypeUrl
         * @memberof pricestream.OrderUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        OrderUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/pricestream.OrderUpdate";
        };

        return OrderUpdate;
    })();

    pricestream.UserOrderKey = (function() {

        /**
         * Properties of a UserOrderKey.
         * @memberof pricestream
         * @interface IUserOrderKey
         * @property {number|null} [epoch] UserOrderKey epoch
         * @property {Uint8Array|null} [key] UserOrderKey key
         */

        /**
         * Constructs a new UserOrderKey.
         * @memberof pricestream
         * @classdesc Represents a UserOrderKey.
         * @implements IUserOrderKey
         * @constructor
         * @param {pricestream.IUserOrderKey=} [properties] Properties to set
         */
        function UserOrderKey(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UserOrderKey epoch.
         * @member {number} epoch
         * @memberof pricestream.UserOrderKey
         * @instance
         */
        UserOrderKey.prototype.epoch = 0;

        /**
         * UserOrderKey key.
         * @member {Uint8Array} key
         * @memberof pricestream.UserOrderKey
         * @instance
         */
        UserOrderKey.prototype.key = $util.newBuffer([]);

        /**
         * Creates a new UserOrderKey instance using the specified properties.
         * @function create
         * @memberof pricestream.UserOrderKey
         * @static
         * @param {pricestream.IUserOrderKey=} [properties] Properties to set
         * @returns {pricestream.UserOrderKey} UserOrderKey instance
         */
        UserOrderKey.create = function create(properties) {
            return new UserOrderKey(properties);
        };

        /**
         * Encodes the specified UserOrderKey message. Does not implicitly {@link pricestream.UserOrderKey.verify|verify} messages.
         * @function encode
         * @memberof pricestream.UserOrderKey
         * @static
         * @param {pricestream.IUserOrderKey} message UserOrderKey message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserOrderKey.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.epoch != null && Object.hasOwnProperty.call(message, "epoch"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.epoch);
            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.key);
            return writer;
        };

        /**
         * Encodes the specified UserOrderKey message, length delimited. Does not implicitly {@link pricestream.UserOrderKey.verify|verify} messages.
         * @function encodeDelimited
         * @memberof pricestream.UserOrderKey
         * @static
         * @param {pricestream.IUserOrderKey} message UserOrderKey message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserOrderKey.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a UserOrderKey message from the specified reader or buffer.
         * @function decode
         * @memberof pricestream.UserOrderKey
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {pricestream.UserOrderKey} UserOrderKey
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserOrderKey.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.pricestream.UserOrderKey();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.epoch = reader.uint32();
                        break;
                    }
                case 2: {
                        message.key = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a UserOrderKey message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof pricestream.UserOrderKey
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {pricestream.UserOrderKey} UserOrderKey
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserOrderKey.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a UserOrderKey message.
         * @function verify
         * @memberof pricestream.UserOrderKey
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UserOrderKey.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.epoch != null && message.hasOwnProperty("epoch"))
                if (!$util.isInteger(message.epoch))
                    return "epoch: integer expected";
            if (message.key != null && message.hasOwnProperty("key"))
                if (!(message.key && typeof message.key.length === "number" || $util.isString(message.key)))
                    return "key: buffer expected";
            return null;
        };

        /**
         * Creates a UserOrderKey message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pricestream.UserOrderKey
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pricestream.UserOrderKey} UserOrderKey
         */
        UserOrderKey.fromObject = function fromObject(object) {
            if (object instanceof $root.pricestream.UserOrderKey)
                return object;
            let message = new $root.pricestream.UserOrderKey();
            if (object.epoch != null)
                message.epoch = object.epoch >>> 0;
            if (object.key != null)
                if (typeof object.key === "string")
                    $util.base64.decode(object.key, message.key = $util.newBuffer($util.base64.length(object.key)), 0);
                else if (object.key.length >= 0)
                    message.key = object.key;
            return message;
        };

        /**
         * Creates a plain object from a UserOrderKey message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pricestream.UserOrderKey
         * @static
         * @param {pricestream.UserOrderKey} message UserOrderKey
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserOrderKey.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.epoch = 0;
                if (options.bytes === String)
                    object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array)
                        object.key = $util.newBuffer(object.key);
                }
            }
            if (message.epoch != null && message.hasOwnProperty("epoch"))
                object.epoch = message.epoch;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = options.bytes === String ? $util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            return object;
        };

        /**
         * Converts this UserOrderKey to JSON.
         * @function toJSON
         * @memberof pricestream.UserOrderKey
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserOrderKey.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UserOrderKey
         * @function getTypeUrl
         * @memberof pricestream.UserOrderKey
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UserOrderKey.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/pricestream.UserOrderKey";
        };

        return UserOrderKey;
    })();

    pricestream.SideOrder = (function() {

        /**
         * Properties of a SideOrder.
         * @memberof pricestream
         * @interface ISideOrder
         * @property {string|null} [id] SideOrder id
         * @property {string|null} [type] SideOrder type
         * @property {number|null} [sumUntaken] SideOrder sumUntaken
         * @property {number|null} [odds] SideOrder odds
         * @property {number|null} [bet] SideOrder bet
         * @property {string|null} [gameId] SideOrder gameId
         * @property {number|null} [takenRatio] SideOrder takenRatio
         * @property {string|null} [participantId] SideOrder participantId
         * @property {string|null} [market] SideOrder market
         * @property {string|null} [side] SideOrder side
         * @property {number|null} [total] SideOrder total
         * @property {number|null} [spread] SideOrder spread
         * @property {string|null} [ou] SideOrder ou
         * @property {string|null} [createdBy] SideOrder createdBy
         * @property {number|Long|null} [expiryUnixMs] SideOrder expiryUnixMs
         * @property {number|Long|null} [createdAtUnixMs] SideOrder createdAtUnixMs
         * @property {boolean|null} [gameStartExpiry] SideOrder gameStartExpiry
         * @property {string|null} [mac] SideOrder mac
         * @property {boolean|null} [isPostArb] SideOrder isPostArb
         */

        /**
         * Constructs a new SideOrder.
         * @memberof pricestream
         * @classdesc Represents a SideOrder.
         * @implements ISideOrder
         * @constructor
         * @param {pricestream.ISideOrder=} [properties] Properties to set
         */
        function SideOrder(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SideOrder id.
         * @member {string} id
         * @memberof pricestream.SideOrder
         * @instance
         */
        SideOrder.prototype.id = "";

        /**
         * SideOrder type.
         * @member {string} type
         * @memberof pricestream.SideOrder
         * @instance
         */
        SideOrder.prototype.type = "";

        /**
         * SideOrder sumUntaken.
         * @member {number} sumUntaken
         * @memberof pricestream.SideOrder
         * @instance
         */
        SideOrder.prototype.sumUntaken = 0;

        /**
         * SideOrder odds.
         * @member {number} odds
         * @memberof pricestream.SideOrder
         * @instance
         */
        SideOrder.prototype.odds = 0;

        /**
         * SideOrder bet.
         * @member {number} bet
         * @memberof pricestream.SideOrder
         * @instance
         */
        SideOrder.prototype.bet = 0;

        /**
         * SideOrder gameId.
         * @member {string} gameId
         * @memberof pricestream.SideOrder
         * @instance
         */
        SideOrder.prototype.gameId = "";

        /**
         * SideOrder takenRatio.
         * @member {number} takenRatio
         * @memberof pricestream.SideOrder
         * @instance
         */
        SideOrder.prototype.takenRatio = 0;

        /**
         * SideOrder participantId.
         * @member {string} participantId
         * @memberof pricestream.SideOrder
         * @instance
         */
        SideOrder.prototype.participantId = "";

        /**
         * SideOrder market.
         * @member {string} market
         * @memberof pricestream.SideOrder
         * @instance
         */
        SideOrder.prototype.market = "";

        /**
         * SideOrder side.
         * @member {string} side
         * @memberof pricestream.SideOrder
         * @instance
         */
        SideOrder.prototype.side = "";

        /**
         * SideOrder total.
         * @member {number|null|undefined} total
         * @memberof pricestream.SideOrder
         * @instance
         */
        SideOrder.prototype.total = null;

        /**
         * SideOrder spread.
         * @member {number|null|undefined} spread
         * @memberof pricestream.SideOrder
         * @instance
         */
        SideOrder.prototype.spread = null;

        /**
         * SideOrder ou.
         * @member {string} ou
         * @memberof pricestream.SideOrder
         * @instance
         */
        SideOrder.prototype.ou = "";

        /**
         * SideOrder createdBy.
         * @member {string|null|undefined} createdBy
         * @memberof pricestream.SideOrder
         * @instance
         */
        SideOrder.prototype.createdBy = null;

        /**
         * SideOrder expiryUnixMs.
         * @member {number|Long} expiryUnixMs
         * @memberof pricestream.SideOrder
         * @instance
         */
        SideOrder.prototype.expiryUnixMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SideOrder createdAtUnixMs.
         * @member {number|Long} createdAtUnixMs
         * @memberof pricestream.SideOrder
         * @instance
         */
        SideOrder.prototype.createdAtUnixMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SideOrder gameStartExpiry.
         * @member {boolean} gameStartExpiry
         * @memberof pricestream.SideOrder
         * @instance
         */
        SideOrder.prototype.gameStartExpiry = false;

        /**
         * SideOrder mac.
         * @member {string} mac
         * @memberof pricestream.SideOrder
         * @instance
         */
        SideOrder.prototype.mac = "";

        /**
         * SideOrder isPostArb.
         * @member {boolean} isPostArb
         * @memberof pricestream.SideOrder
         * @instance
         */
        SideOrder.prototype.isPostArb = false;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(SideOrder.prototype, "_total", {
            get: $util.oneOfGetter($oneOfFields = ["total"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(SideOrder.prototype, "_spread", {
            get: $util.oneOfGetter($oneOfFields = ["spread"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(SideOrder.prototype, "_createdBy", {
            get: $util.oneOfGetter($oneOfFields = ["createdBy"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new SideOrder instance using the specified properties.
         * @function create
         * @memberof pricestream.SideOrder
         * @static
         * @param {pricestream.ISideOrder=} [properties] Properties to set
         * @returns {pricestream.SideOrder} SideOrder instance
         */
        SideOrder.create = function create(properties) {
            return new SideOrder(properties);
        };

        /**
         * Encodes the specified SideOrder message. Does not implicitly {@link pricestream.SideOrder.verify|verify} messages.
         * @function encode
         * @memberof pricestream.SideOrder
         * @static
         * @param {pricestream.ISideOrder} message SideOrder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SideOrder.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.type);
            if (message.sumUntaken != null && Object.hasOwnProperty.call(message, "sumUntaken"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.sumUntaken);
            if (message.odds != null && Object.hasOwnProperty.call(message, "odds"))
                writer.uint32(/* id 4, wireType 1 =*/33).double(message.odds);
            if (message.bet != null && Object.hasOwnProperty.call(message, "bet"))
                writer.uint32(/* id 5, wireType 1 =*/41).double(message.bet);
            if (message.gameId != null && Object.hasOwnProperty.call(message, "gameId"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.gameId);
            if (message.takenRatio != null && Object.hasOwnProperty.call(message, "takenRatio"))
                writer.uint32(/* id 7, wireType 1 =*/57).double(message.takenRatio);
            if (message.participantId != null && Object.hasOwnProperty.call(message, "participantId"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.participantId);
            if (message.market != null && Object.hasOwnProperty.call(message, "market"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.market);
            if (message.side != null && Object.hasOwnProperty.call(message, "side"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.side);
            if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                writer.uint32(/* id 11, wireType 1 =*/89).double(message.total);
            if (message.spread != null && Object.hasOwnProperty.call(message, "spread"))
                writer.uint32(/* id 12, wireType 1 =*/97).double(message.spread);
            if (message.ou != null && Object.hasOwnProperty.call(message, "ou"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.ou);
            if (message.createdBy != null && Object.hasOwnProperty.call(message, "createdBy"))
                writer.uint32(/* id 14, wireType 2 =*/114).string(message.createdBy);
            if (message.expiryUnixMs != null && Object.hasOwnProperty.call(message, "expiryUnixMs"))
                writer.uint32(/* id 15, wireType 0 =*/120).int64(message.expiryUnixMs);
            if (message.createdAtUnixMs != null && Object.hasOwnProperty.call(message, "createdAtUnixMs"))
                writer.uint32(/* id 16, wireType 0 =*/128).int64(message.createdAtUnixMs);
            if (message.gameStartExpiry != null && Object.hasOwnProperty.call(message, "gameStartExpiry"))
                writer.uint32(/* id 17, wireType 0 =*/136).bool(message.gameStartExpiry);
            if (message.mac != null && Object.hasOwnProperty.call(message, "mac"))
                writer.uint32(/* id 18, wireType 2 =*/146).string(message.mac);
            if (message.isPostArb != null && Object.hasOwnProperty.call(message, "isPostArb"))
                writer.uint32(/* id 19, wireType 0 =*/152).bool(message.isPostArb);
            return writer;
        };

        /**
         * Encodes the specified SideOrder message, length delimited. Does not implicitly {@link pricestream.SideOrder.verify|verify} messages.
         * @function encodeDelimited
         * @memberof pricestream.SideOrder
         * @static
         * @param {pricestream.ISideOrder} message SideOrder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SideOrder.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SideOrder message from the specified reader or buffer.
         * @function decode
         * @memberof pricestream.SideOrder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {pricestream.SideOrder} SideOrder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SideOrder.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.pricestream.SideOrder();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.type = reader.string();
                        break;
                    }
                case 3: {
                        message.sumUntaken = reader.double();
                        break;
                    }
                case 4: {
                        message.odds = reader.double();
                        break;
                    }
                case 5: {
                        message.bet = reader.double();
                        break;
                    }
                case 6: {
                        message.gameId = reader.string();
                        break;
                    }
                case 7: {
                        message.takenRatio = reader.double();
                        break;
                    }
                case 8: {
                        message.participantId = reader.string();
                        break;
                    }
                case 9: {
                        message.market = reader.string();
                        break;
                    }
                case 10: {
                        message.side = reader.string();
                        break;
                    }
                case 11: {
                        message.total = reader.double();
                        break;
                    }
                case 12: {
                        message.spread = reader.double();
                        break;
                    }
                case 13: {
                        message.ou = reader.string();
                        break;
                    }
                case 14: {
                        message.createdBy = reader.string();
                        break;
                    }
                case 15: {
                        message.expiryUnixMs = reader.int64();
                        break;
                    }
                case 16: {
                        message.createdAtUnixMs = reader.int64();
                        break;
                    }
                case 17: {
                        message.gameStartExpiry = reader.bool();
                        break;
                    }
                case 18: {
                        message.mac = reader.string();
                        break;
                    }
                case 19: {
                        message.isPostArb = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SideOrder message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof pricestream.SideOrder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {pricestream.SideOrder} SideOrder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SideOrder.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SideOrder message.
         * @function verify
         * @memberof pricestream.SideOrder
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SideOrder.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isString(message.type))
                    return "type: string expected";
            if (message.sumUntaken != null && message.hasOwnProperty("sumUntaken"))
                if (typeof message.sumUntaken !== "number")
                    return "sumUntaken: number expected";
            if (message.odds != null && message.hasOwnProperty("odds"))
                if (typeof message.odds !== "number")
                    return "odds: number expected";
            if (message.bet != null && message.hasOwnProperty("bet"))
                if (typeof message.bet !== "number")
                    return "bet: number expected";
            if (message.gameId != null && message.hasOwnProperty("gameId"))
                if (!$util.isString(message.gameId))
                    return "gameId: string expected";
            if (message.takenRatio != null && message.hasOwnProperty("takenRatio"))
                if (typeof message.takenRatio !== "number")
                    return "takenRatio: number expected";
            if (message.participantId != null && message.hasOwnProperty("participantId"))
                if (!$util.isString(message.participantId))
                    return "participantId: string expected";
            if (message.market != null && message.hasOwnProperty("market"))
                if (!$util.isString(message.market))
                    return "market: string expected";
            if (message.side != null && message.hasOwnProperty("side"))
                if (!$util.isString(message.side))
                    return "side: string expected";
            if (message.total != null && message.hasOwnProperty("total")) {
                properties._total = 1;
                if (typeof message.total !== "number")
                    return "total: number expected";
            }
            if (message.spread != null && message.hasOwnProperty("spread")) {
                properties._spread = 1;
                if (typeof message.spread !== "number")
                    return "spread: number expected";
            }
            if (message.ou != null && message.hasOwnProperty("ou"))
                if (!$util.isString(message.ou))
                    return "ou: string expected";
            if (message.createdBy != null && message.hasOwnProperty("createdBy")) {
                properties._createdBy = 1;
                if (!$util.isString(message.createdBy))
                    return "createdBy: string expected";
            }
            if (message.expiryUnixMs != null && message.hasOwnProperty("expiryUnixMs"))
                if (!$util.isInteger(message.expiryUnixMs) && !(message.expiryUnixMs && $util.isInteger(message.expiryUnixMs.low) && $util.isInteger(message.expiryUnixMs.high)))
                    return "expiryUnixMs: integer|Long expected";
            if (message.createdAtUnixMs != null && message.hasOwnProperty("createdAtUnixMs"))
                if (!$util.isInteger(message.createdAtUnixMs) && !(message.createdAtUnixMs && $util.isInteger(message.createdAtUnixMs.low) && $util.isInteger(message.createdAtUnixMs.high)))
                    return "createdAtUnixMs: integer|Long expected";
            if (message.gameStartExpiry != null && message.hasOwnProperty("gameStartExpiry"))
                if (typeof message.gameStartExpiry !== "boolean")
                    return "gameStartExpiry: boolean expected";
            if (message.mac != null && message.hasOwnProperty("mac"))
                if (!$util.isString(message.mac))
                    return "mac: string expected";
            if (message.isPostArb != null && message.hasOwnProperty("isPostArb"))
                if (typeof message.isPostArb !== "boolean")
                    return "isPostArb: boolean expected";
            return null;
        };

        /**
         * Creates a SideOrder message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pricestream.SideOrder
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pricestream.SideOrder} SideOrder
         */
        SideOrder.fromObject = function fromObject(object) {
            if (object instanceof $root.pricestream.SideOrder)
                return object;
            let message = new $root.pricestream.SideOrder();
            if (object.id != null)
                message.id = String(object.id);
            if (object.type != null)
                message.type = String(object.type);
            if (object.sumUntaken != null)
                message.sumUntaken = Number(object.sumUntaken);
            if (object.odds != null)
                message.odds = Number(object.odds);
            if (object.bet != null)
                message.bet = Number(object.bet);
            if (object.gameId != null)
                message.gameId = String(object.gameId);
            if (object.takenRatio != null)
                message.takenRatio = Number(object.takenRatio);
            if (object.participantId != null)
                message.participantId = String(object.participantId);
            if (object.market != null)
                message.market = String(object.market);
            if (object.side != null)
                message.side = String(object.side);
            if (object.total != null)
                message.total = Number(object.total);
            if (object.spread != null)
                message.spread = Number(object.spread);
            if (object.ou != null)
                message.ou = String(object.ou);
            if (object.createdBy != null)
                message.createdBy = String(object.createdBy);
            if (object.expiryUnixMs != null)
                if ($util.Long)
                    (message.expiryUnixMs = $util.Long.fromValue(object.expiryUnixMs)).unsigned = false;
                else if (typeof object.expiryUnixMs === "string")
                    message.expiryUnixMs = parseInt(object.expiryUnixMs, 10);
                else if (typeof object.expiryUnixMs === "number")
                    message.expiryUnixMs = object.expiryUnixMs;
                else if (typeof object.expiryUnixMs === "object")
                    message.expiryUnixMs = new $util.LongBits(object.expiryUnixMs.low >>> 0, object.expiryUnixMs.high >>> 0).toNumber();
            if (object.createdAtUnixMs != null)
                if ($util.Long)
                    (message.createdAtUnixMs = $util.Long.fromValue(object.createdAtUnixMs)).unsigned = false;
                else if (typeof object.createdAtUnixMs === "string")
                    message.createdAtUnixMs = parseInt(object.createdAtUnixMs, 10);
                else if (typeof object.createdAtUnixMs === "number")
                    message.createdAtUnixMs = object.createdAtUnixMs;
                else if (typeof object.createdAtUnixMs === "object")
                    message.createdAtUnixMs = new $util.LongBits(object.createdAtUnixMs.low >>> 0, object.createdAtUnixMs.high >>> 0).toNumber();
            if (object.gameStartExpiry != null)
                message.gameStartExpiry = Boolean(object.gameStartExpiry);
            if (object.mac != null)
                message.mac = String(object.mac);
            if (object.isPostArb != null)
                message.isPostArb = Boolean(object.isPostArb);
            return message;
        };

        /**
         * Creates a plain object from a SideOrder message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pricestream.SideOrder
         * @static
         * @param {pricestream.SideOrder} message SideOrder
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SideOrder.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.id = "";
                object.type = "";
                object.sumUntaken = 0;
                object.odds = 0;
                object.bet = 0;
                object.gameId = "";
                object.takenRatio = 0;
                object.participantId = "";
                object.market = "";
                object.side = "";
                object.ou = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.expiryUnixMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.expiryUnixMs = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.createdAtUnixMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdAtUnixMs = options.longs === String ? "0" : 0;
                object.gameStartExpiry = false;
                object.mac = "";
                object.isPostArb = false;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.sumUntaken != null && message.hasOwnProperty("sumUntaken"))
                object.sumUntaken = options.json && !isFinite(message.sumUntaken) ? String(message.sumUntaken) : message.sumUntaken;
            if (message.odds != null && message.hasOwnProperty("odds"))
                object.odds = options.json && !isFinite(message.odds) ? String(message.odds) : message.odds;
            if (message.bet != null && message.hasOwnProperty("bet"))
                object.bet = options.json && !isFinite(message.bet) ? String(message.bet) : message.bet;
            if (message.gameId != null && message.hasOwnProperty("gameId"))
                object.gameId = message.gameId;
            if (message.takenRatio != null && message.hasOwnProperty("takenRatio"))
                object.takenRatio = options.json && !isFinite(message.takenRatio) ? String(message.takenRatio) : message.takenRatio;
            if (message.participantId != null && message.hasOwnProperty("participantId"))
                object.participantId = message.participantId;
            if (message.market != null && message.hasOwnProperty("market"))
                object.market = message.market;
            if (message.side != null && message.hasOwnProperty("side"))
                object.side = message.side;
            if (message.total != null && message.hasOwnProperty("total")) {
                object.total = options.json && !isFinite(message.total) ? String(message.total) : message.total;
                if (options.oneofs)
                    object._total = "total";
            }
            if (message.spread != null && message.hasOwnProperty("spread")) {
                object.spread = options.json && !isFinite(message.spread) ? String(message.spread) : message.spread;
                if (options.oneofs)
                    object._spread = "spread";
            }
            if (message.ou != null && message.hasOwnProperty("ou"))
                object.ou = message.ou;
            if (message.createdBy != null && message.hasOwnProperty("createdBy")) {
                object.createdBy = message.createdBy;
                if (options.oneofs)
                    object._createdBy = "createdBy";
            }
            if (message.expiryUnixMs != null && message.hasOwnProperty("expiryUnixMs"))
                if (typeof message.expiryUnixMs === "number")
                    object.expiryUnixMs = options.longs === String ? String(message.expiryUnixMs) : message.expiryUnixMs;
                else
                    object.expiryUnixMs = options.longs === String ? $util.Long.prototype.toString.call(message.expiryUnixMs) : options.longs === Number ? new $util.LongBits(message.expiryUnixMs.low >>> 0, message.expiryUnixMs.high >>> 0).toNumber() : message.expiryUnixMs;
            if (message.createdAtUnixMs != null && message.hasOwnProperty("createdAtUnixMs"))
                if (typeof message.createdAtUnixMs === "number")
                    object.createdAtUnixMs = options.longs === String ? String(message.createdAtUnixMs) : message.createdAtUnixMs;
                else
                    object.createdAtUnixMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdAtUnixMs) : options.longs === Number ? new $util.LongBits(message.createdAtUnixMs.low >>> 0, message.createdAtUnixMs.high >>> 0).toNumber() : message.createdAtUnixMs;
            if (message.gameStartExpiry != null && message.hasOwnProperty("gameStartExpiry"))
                object.gameStartExpiry = message.gameStartExpiry;
            if (message.mac != null && message.hasOwnProperty("mac"))
                object.mac = message.mac;
            if (message.isPostArb != null && message.hasOwnProperty("isPostArb"))
                object.isPostArb = message.isPostArb;
            return object;
        };

        /**
         * Converts this SideOrder to JSON.
         * @function toJSON
         * @memberof pricestream.SideOrder
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SideOrder.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SideOrder
         * @function getTypeUrl
         * @memberof pricestream.SideOrder
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SideOrder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/pricestream.SideOrder";
        };

        return SideOrder;
    })();

    pricestream.GameUpdate = (function() {

        /**
         * Properties of a GameUpdate.
         * @memberof pricestream
         * @interface IGameUpdate
         * @property {string|null} [id] GameUpdate id
         * @property {string|null} [sport] GameUpdate sport
         * @property {string|null} [league] GameUpdate league
         * @property {string|null} [homeName] GameUpdate homeName
         * @property {string|null} [awayName] GameUpdate awayName
         * @property {string|null} [homeId] GameUpdate homeId
         * @property {string|null} [awayId] GameUpdate awayId
         * @property {number|Long|null} [startUnixMs] GameUpdate startUnixMs
         * @property {boolean|null} [live] GameUpdate live
         * @property {boolean|null} [ended] GameUpdate ended
         * @property {boolean|null} [graded] GameUpdate graded
         * @property {number|null} [homeScore] GameUpdate homeScore
         * @property {number|null} [awayScore] GameUpdate awayScore
         * @property {number|null} [matchedVolume] GameUpdate matchedVolume
         * @property {string|null} [extraJson] GameUpdate extraJson
         */

        /**
         * Constructs a new GameUpdate.
         * @memberof pricestream
         * @classdesc Represents a GameUpdate.
         * @implements IGameUpdate
         * @constructor
         * @param {pricestream.IGameUpdate=} [properties] Properties to set
         */
        function GameUpdate(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GameUpdate id.
         * @member {string} id
         * @memberof pricestream.GameUpdate
         * @instance
         */
        GameUpdate.prototype.id = "";

        /**
         * GameUpdate sport.
         * @member {string} sport
         * @memberof pricestream.GameUpdate
         * @instance
         */
        GameUpdate.prototype.sport = "";

        /**
         * GameUpdate league.
         * @member {string} league
         * @memberof pricestream.GameUpdate
         * @instance
         */
        GameUpdate.prototype.league = "";

        /**
         * GameUpdate homeName.
         * @member {string} homeName
         * @memberof pricestream.GameUpdate
         * @instance
         */
        GameUpdate.prototype.homeName = "";

        /**
         * GameUpdate awayName.
         * @member {string} awayName
         * @memberof pricestream.GameUpdate
         * @instance
         */
        GameUpdate.prototype.awayName = "";

        /**
         * GameUpdate homeId.
         * @member {string} homeId
         * @memberof pricestream.GameUpdate
         * @instance
         */
        GameUpdate.prototype.homeId = "";

        /**
         * GameUpdate awayId.
         * @member {string} awayId
         * @memberof pricestream.GameUpdate
         * @instance
         */
        GameUpdate.prototype.awayId = "";

        /**
         * GameUpdate startUnixMs.
         * @member {number|Long} startUnixMs
         * @memberof pricestream.GameUpdate
         * @instance
         */
        GameUpdate.prototype.startUnixMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * GameUpdate live.
         * @member {boolean} live
         * @memberof pricestream.GameUpdate
         * @instance
         */
        GameUpdate.prototype.live = false;

        /**
         * GameUpdate ended.
         * @member {boolean} ended
         * @memberof pricestream.GameUpdate
         * @instance
         */
        GameUpdate.prototype.ended = false;

        /**
         * GameUpdate graded.
         * @member {boolean} graded
         * @memberof pricestream.GameUpdate
         * @instance
         */
        GameUpdate.prototype.graded = false;

        /**
         * GameUpdate homeScore.
         * @member {number|null|undefined} homeScore
         * @memberof pricestream.GameUpdate
         * @instance
         */
        GameUpdate.prototype.homeScore = null;

        /**
         * GameUpdate awayScore.
         * @member {number|null|undefined} awayScore
         * @memberof pricestream.GameUpdate
         * @instance
         */
        GameUpdate.prototype.awayScore = null;

        /**
         * GameUpdate matchedVolume.
         * @member {number} matchedVolume
         * @memberof pricestream.GameUpdate
         * @instance
         */
        GameUpdate.prototype.matchedVolume = 0;

        /**
         * GameUpdate extraJson.
         * @member {string} extraJson
         * @memberof pricestream.GameUpdate
         * @instance
         */
        GameUpdate.prototype.extraJson = "";

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GameUpdate.prototype, "_homeScore", {
            get: $util.oneOfGetter($oneOfFields = ["homeScore"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GameUpdate.prototype, "_awayScore", {
            get: $util.oneOfGetter($oneOfFields = ["awayScore"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GameUpdate instance using the specified properties.
         * @function create
         * @memberof pricestream.GameUpdate
         * @static
         * @param {pricestream.IGameUpdate=} [properties] Properties to set
         * @returns {pricestream.GameUpdate} GameUpdate instance
         */
        GameUpdate.create = function create(properties) {
            return new GameUpdate(properties);
        };

        /**
         * Encodes the specified GameUpdate message. Does not implicitly {@link pricestream.GameUpdate.verify|verify} messages.
         * @function encode
         * @memberof pricestream.GameUpdate
         * @static
         * @param {pricestream.IGameUpdate} message GameUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.sport != null && Object.hasOwnProperty.call(message, "sport"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.sport);
            if (message.league != null && Object.hasOwnProperty.call(message, "league"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.league);
            if (message.homeName != null && Object.hasOwnProperty.call(message, "homeName"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.homeName);
            if (message.awayName != null && Object.hasOwnProperty.call(message, "awayName"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.awayName);
            if (message.homeId != null && Object.hasOwnProperty.call(message, "homeId"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.homeId);
            if (message.awayId != null && Object.hasOwnProperty.call(message, "awayId"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.awayId);
            if (message.startUnixMs != null && Object.hasOwnProperty.call(message, "startUnixMs"))
                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.startUnixMs);
            if (message.live != null && Object.hasOwnProperty.call(message, "live"))
                writer.uint32(/* id 9, wireType 0 =*/72).bool(message.live);
            if (message.ended != null && Object.hasOwnProperty.call(message, "ended"))
                writer.uint32(/* id 10, wireType 0 =*/80).bool(message.ended);
            if (message.graded != null && Object.hasOwnProperty.call(message, "graded"))
                writer.uint32(/* id 11, wireType 0 =*/88).bool(message.graded);
            if (message.homeScore != null && Object.hasOwnProperty.call(message, "homeScore"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.homeScore);
            if (message.awayScore != null && Object.hasOwnProperty.call(message, "awayScore"))
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.awayScore);
            if (message.matchedVolume != null && Object.hasOwnProperty.call(message, "matchedVolume"))
                writer.uint32(/* id 14, wireType 1 =*/113).double(message.matchedVolume);
            if (message.extraJson != null && Object.hasOwnProperty.call(message, "extraJson"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.extraJson);
            return writer;
        };

        /**
         * Encodes the specified GameUpdate message, length delimited. Does not implicitly {@link pricestream.GameUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof pricestream.GameUpdate
         * @static
         * @param {pricestream.IGameUpdate} message GameUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GameUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof pricestream.GameUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {pricestream.GameUpdate} GameUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameUpdate.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.pricestream.GameUpdate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.sport = reader.string();
                        break;
                    }
                case 3: {
                        message.league = reader.string();
                        break;
                    }
                case 4: {
                        message.homeName = reader.string();
                        break;
                    }
                case 5: {
                        message.awayName = reader.string();
                        break;
                    }
                case 6: {
                        message.homeId = reader.string();
                        break;
                    }
                case 7: {
                        message.awayId = reader.string();
                        break;
                    }
                case 8: {
                        message.startUnixMs = reader.int64();
                        break;
                    }
                case 9: {
                        message.live = reader.bool();
                        break;
                    }
                case 10: {
                        message.ended = reader.bool();
                        break;
                    }
                case 11: {
                        message.graded = reader.bool();
                        break;
                    }
                case 12: {
                        message.homeScore = reader.int32();
                        break;
                    }
                case 13: {
                        message.awayScore = reader.int32();
                        break;
                    }
                case 14: {
                        message.matchedVolume = reader.double();
                        break;
                    }
                case 15: {
                        message.extraJson = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GameUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof pricestream.GameUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {pricestream.GameUpdate} GameUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GameUpdate message.
         * @function verify
         * @memberof pricestream.GameUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GameUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.sport != null && message.hasOwnProperty("sport"))
                if (!$util.isString(message.sport))
                    return "sport: string expected";
            if (message.league != null && message.hasOwnProperty("league"))
                if (!$util.isString(message.league))
                    return "league: string expected";
            if (message.homeName != null && message.hasOwnProperty("homeName"))
                if (!$util.isString(message.homeName))
                    return "homeName: string expected";
            if (message.awayName != null && message.hasOwnProperty("awayName"))
                if (!$util.isString(message.awayName))
                    return "awayName: string expected";
            if (message.homeId != null && message.hasOwnProperty("homeId"))
                if (!$util.isString(message.homeId))
                    return "homeId: string expected";
            if (message.awayId != null && message.hasOwnProperty("awayId"))
                if (!$util.isString(message.awayId))
                    return "awayId: string expected";
            if (message.startUnixMs != null && message.hasOwnProperty("startUnixMs"))
                if (!$util.isInteger(message.startUnixMs) && !(message.startUnixMs && $util.isInteger(message.startUnixMs.low) && $util.isInteger(message.startUnixMs.high)))
                    return "startUnixMs: integer|Long expected";
            if (message.live != null && message.hasOwnProperty("live"))
                if (typeof message.live !== "boolean")
                    return "live: boolean expected";
            if (message.ended != null && message.hasOwnProperty("ended"))
                if (typeof message.ended !== "boolean")
                    return "ended: boolean expected";
            if (message.graded != null && message.hasOwnProperty("graded"))
                if (typeof message.graded !== "boolean")
                    return "graded: boolean expected";
            if (message.homeScore != null && message.hasOwnProperty("homeScore")) {
                properties._homeScore = 1;
                if (!$util.isInteger(message.homeScore))
                    return "homeScore: integer expected";
            }
            if (message.awayScore != null && message.hasOwnProperty("awayScore")) {
                properties._awayScore = 1;
                if (!$util.isInteger(message.awayScore))
                    return "awayScore: integer expected";
            }
            if (message.matchedVolume != null && message.hasOwnProperty("matchedVolume"))
                if (typeof message.matchedVolume !== "number")
                    return "matchedVolume: number expected";
            if (message.extraJson != null && message.hasOwnProperty("extraJson"))
                if (!$util.isString(message.extraJson))
                    return "extraJson: string expected";
            return null;
        };

        /**
         * Creates a GameUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pricestream.GameUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pricestream.GameUpdate} GameUpdate
         */
        GameUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.pricestream.GameUpdate)
                return object;
            let message = new $root.pricestream.GameUpdate();
            if (object.id != null)
                message.id = String(object.id);
            if (object.sport != null)
                message.sport = String(object.sport);
            if (object.league != null)
                message.league = String(object.league);
            if (object.homeName != null)
                message.homeName = String(object.homeName);
            if (object.awayName != null)
                message.awayName = String(object.awayName);
            if (object.homeId != null)
                message.homeId = String(object.homeId);
            if (object.awayId != null)
                message.awayId = String(object.awayId);
            if (object.startUnixMs != null)
                if ($util.Long)
                    (message.startUnixMs = $util.Long.fromValue(object.startUnixMs)).unsigned = false;
                else if (typeof object.startUnixMs === "string")
                    message.startUnixMs = parseInt(object.startUnixMs, 10);
                else if (typeof object.startUnixMs === "number")
                    message.startUnixMs = object.startUnixMs;
                else if (typeof object.startUnixMs === "object")
                    message.startUnixMs = new $util.LongBits(object.startUnixMs.low >>> 0, object.startUnixMs.high >>> 0).toNumber();
            if (object.live != null)
                message.live = Boolean(object.live);
            if (object.ended != null)
                message.ended = Boolean(object.ended);
            if (object.graded != null)
                message.graded = Boolean(object.graded);
            if (object.homeScore != null)
                message.homeScore = object.homeScore | 0;
            if (object.awayScore != null)
                message.awayScore = object.awayScore | 0;
            if (object.matchedVolume != null)
                message.matchedVolume = Number(object.matchedVolume);
            if (object.extraJson != null)
                message.extraJson = String(object.extraJson);
            return message;
        };

        /**
         * Creates a plain object from a GameUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pricestream.GameUpdate
         * @static
         * @param {pricestream.GameUpdate} message GameUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GameUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.id = "";
                object.sport = "";
                object.league = "";
                object.homeName = "";
                object.awayName = "";
                object.homeId = "";
                object.awayId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.startUnixMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.startUnixMs = options.longs === String ? "0" : 0;
                object.live = false;
                object.ended = false;
                object.graded = false;
                object.matchedVolume = 0;
                object.extraJson = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.sport != null && message.hasOwnProperty("sport"))
                object.sport = message.sport;
            if (message.league != null && message.hasOwnProperty("league"))
                object.league = message.league;
            if (message.homeName != null && message.hasOwnProperty("homeName"))
                object.homeName = message.homeName;
            if (message.awayName != null && message.hasOwnProperty("awayName"))
                object.awayName = message.awayName;
            if (message.homeId != null && message.hasOwnProperty("homeId"))
                object.homeId = message.homeId;
            if (message.awayId != null && message.hasOwnProperty("awayId"))
                object.awayId = message.awayId;
            if (message.startUnixMs != null && message.hasOwnProperty("startUnixMs"))
                if (typeof message.startUnixMs === "number")
                    object.startUnixMs = options.longs === String ? String(message.startUnixMs) : message.startUnixMs;
                else
                    object.startUnixMs = options.longs === String ? $util.Long.prototype.toString.call(message.startUnixMs) : options.longs === Number ? new $util.LongBits(message.startUnixMs.low >>> 0, message.startUnixMs.high >>> 0).toNumber() : message.startUnixMs;
            if (message.live != null && message.hasOwnProperty("live"))
                object.live = message.live;
            if (message.ended != null && message.hasOwnProperty("ended"))
                object.ended = message.ended;
            if (message.graded != null && message.hasOwnProperty("graded"))
                object.graded = message.graded;
            if (message.homeScore != null && message.hasOwnProperty("homeScore")) {
                object.homeScore = message.homeScore;
                if (options.oneofs)
                    object._homeScore = "homeScore";
            }
            if (message.awayScore != null && message.hasOwnProperty("awayScore")) {
                object.awayScore = message.awayScore;
                if (options.oneofs)
                    object._awayScore = "awayScore";
            }
            if (message.matchedVolume != null && message.hasOwnProperty("matchedVolume"))
                object.matchedVolume = options.json && !isFinite(message.matchedVolume) ? String(message.matchedVolume) : message.matchedVolume;
            if (message.extraJson != null && message.hasOwnProperty("extraJson"))
                object.extraJson = message.extraJson;
            return object;
        };

        /**
         * Converts this GameUpdate to JSON.
         * @function toJSON
         * @memberof pricestream.GameUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GameUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GameUpdate
         * @function getTypeUrl
         * @memberof pricestream.GameUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GameUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/pricestream.GameUpdate";
        };

        return GameUpdate;
    })();

    pricestream.MatchedVolumeUpdate = (function() {

        /**
         * Properties of a MatchedVolumeUpdate.
         * @memberof pricestream
         * @interface IMatchedVolumeUpdate
         * @property {string|null} [gameId] MatchedVolumeUpdate gameId
         * @property {number|null} [matchedVolume] MatchedVolumeUpdate matchedVolume
         * @property {string|null} [rootGameId] MatchedVolumeUpdate rootGameId
         * @property {number|null} [rootGameMatchedVolumeIncludingChildren] MatchedVolumeUpdate rootGameMatchedVolumeIncludingChildren
         */

        /**
         * Constructs a new MatchedVolumeUpdate.
         * @memberof pricestream
         * @classdesc Represents a MatchedVolumeUpdate.
         * @implements IMatchedVolumeUpdate
         * @constructor
         * @param {pricestream.IMatchedVolumeUpdate=} [properties] Properties to set
         */
        function MatchedVolumeUpdate(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MatchedVolumeUpdate gameId.
         * @member {string} gameId
         * @memberof pricestream.MatchedVolumeUpdate
         * @instance
         */
        MatchedVolumeUpdate.prototype.gameId = "";

        /**
         * MatchedVolumeUpdate matchedVolume.
         * @member {number} matchedVolume
         * @memberof pricestream.MatchedVolumeUpdate
         * @instance
         */
        MatchedVolumeUpdate.prototype.matchedVolume = 0;

        /**
         * MatchedVolumeUpdate rootGameId.
         * @member {string} rootGameId
         * @memberof pricestream.MatchedVolumeUpdate
         * @instance
         */
        MatchedVolumeUpdate.prototype.rootGameId = "";

        /**
         * MatchedVolumeUpdate rootGameMatchedVolumeIncludingChildren.
         * @member {number} rootGameMatchedVolumeIncludingChildren
         * @memberof pricestream.MatchedVolumeUpdate
         * @instance
         */
        MatchedVolumeUpdate.prototype.rootGameMatchedVolumeIncludingChildren = 0;

        /**
         * Creates a new MatchedVolumeUpdate instance using the specified properties.
         * @function create
         * @memberof pricestream.MatchedVolumeUpdate
         * @static
         * @param {pricestream.IMatchedVolumeUpdate=} [properties] Properties to set
         * @returns {pricestream.MatchedVolumeUpdate} MatchedVolumeUpdate instance
         */
        MatchedVolumeUpdate.create = function create(properties) {
            return new MatchedVolumeUpdate(properties);
        };

        /**
         * Encodes the specified MatchedVolumeUpdate message. Does not implicitly {@link pricestream.MatchedVolumeUpdate.verify|verify} messages.
         * @function encode
         * @memberof pricestream.MatchedVolumeUpdate
         * @static
         * @param {pricestream.IMatchedVolumeUpdate} message MatchedVolumeUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MatchedVolumeUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.gameId != null && Object.hasOwnProperty.call(message, "gameId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.gameId);
            if (message.matchedVolume != null && Object.hasOwnProperty.call(message, "matchedVolume"))
                writer.uint32(/* id 2, wireType 1 =*/17).double(message.matchedVolume);
            if (message.rootGameId != null && Object.hasOwnProperty.call(message, "rootGameId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.rootGameId);
            if (message.rootGameMatchedVolumeIncludingChildren != null && Object.hasOwnProperty.call(message, "rootGameMatchedVolumeIncludingChildren"))
                writer.uint32(/* id 4, wireType 1 =*/33).double(message.rootGameMatchedVolumeIncludingChildren);
            return writer;
        };

        /**
         * Encodes the specified MatchedVolumeUpdate message, length delimited. Does not implicitly {@link pricestream.MatchedVolumeUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof pricestream.MatchedVolumeUpdate
         * @static
         * @param {pricestream.IMatchedVolumeUpdate} message MatchedVolumeUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MatchedVolumeUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MatchedVolumeUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof pricestream.MatchedVolumeUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {pricestream.MatchedVolumeUpdate} MatchedVolumeUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MatchedVolumeUpdate.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.pricestream.MatchedVolumeUpdate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.gameId = reader.string();
                        break;
                    }
                case 2: {
                        message.matchedVolume = reader.double();
                        break;
                    }
                case 3: {
                        message.rootGameId = reader.string();
                        break;
                    }
                case 4: {
                        message.rootGameMatchedVolumeIncludingChildren = reader.double();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MatchedVolumeUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof pricestream.MatchedVolumeUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {pricestream.MatchedVolumeUpdate} MatchedVolumeUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MatchedVolumeUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MatchedVolumeUpdate message.
         * @function verify
         * @memberof pricestream.MatchedVolumeUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MatchedVolumeUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.gameId != null && message.hasOwnProperty("gameId"))
                if (!$util.isString(message.gameId))
                    return "gameId: string expected";
            if (message.matchedVolume != null && message.hasOwnProperty("matchedVolume"))
                if (typeof message.matchedVolume !== "number")
                    return "matchedVolume: number expected";
            if (message.rootGameId != null && message.hasOwnProperty("rootGameId"))
                if (!$util.isString(message.rootGameId))
                    return "rootGameId: string expected";
            if (message.rootGameMatchedVolumeIncludingChildren != null && message.hasOwnProperty("rootGameMatchedVolumeIncludingChildren"))
                if (typeof message.rootGameMatchedVolumeIncludingChildren !== "number")
                    return "rootGameMatchedVolumeIncludingChildren: number expected";
            return null;
        };

        /**
         * Creates a MatchedVolumeUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pricestream.MatchedVolumeUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pricestream.MatchedVolumeUpdate} MatchedVolumeUpdate
         */
        MatchedVolumeUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.pricestream.MatchedVolumeUpdate)
                return object;
            let message = new $root.pricestream.MatchedVolumeUpdate();
            if (object.gameId != null)
                message.gameId = String(object.gameId);
            if (object.matchedVolume != null)
                message.matchedVolume = Number(object.matchedVolume);
            if (object.rootGameId != null)
                message.rootGameId = String(object.rootGameId);
            if (object.rootGameMatchedVolumeIncludingChildren != null)
                message.rootGameMatchedVolumeIncludingChildren = Number(object.rootGameMatchedVolumeIncludingChildren);
            return message;
        };

        /**
         * Creates a plain object from a MatchedVolumeUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pricestream.MatchedVolumeUpdate
         * @static
         * @param {pricestream.MatchedVolumeUpdate} message MatchedVolumeUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MatchedVolumeUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.gameId = "";
                object.matchedVolume = 0;
                object.rootGameId = "";
                object.rootGameMatchedVolumeIncludingChildren = 0;
            }
            if (message.gameId != null && message.hasOwnProperty("gameId"))
                object.gameId = message.gameId;
            if (message.matchedVolume != null && message.hasOwnProperty("matchedVolume"))
                object.matchedVolume = options.json && !isFinite(message.matchedVolume) ? String(message.matchedVolume) : message.matchedVolume;
            if (message.rootGameId != null && message.hasOwnProperty("rootGameId"))
                object.rootGameId = message.rootGameId;
            if (message.rootGameMatchedVolumeIncludingChildren != null && message.hasOwnProperty("rootGameMatchedVolumeIncludingChildren"))
                object.rootGameMatchedVolumeIncludingChildren = options.json && !isFinite(message.rootGameMatchedVolumeIncludingChildren) ? String(message.rootGameMatchedVolumeIncludingChildren) : message.rootGameMatchedVolumeIncludingChildren;
            return object;
        };

        /**
         * Converts this MatchedVolumeUpdate to JSON.
         * @function toJSON
         * @memberof pricestream.MatchedVolumeUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MatchedVolumeUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MatchedVolumeUpdate
         * @function getTypeUrl
         * @memberof pricestream.MatchedVolumeUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MatchedVolumeUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/pricestream.MatchedVolumeUpdate";
        };

        return MatchedVolumeUpdate;
    })();

    pricestream.ClientCommand = (function() {

        /**
         * Properties of a ClientCommand.
         * @memberof pricestream
         * @interface IClientCommand
         * @property {pricestream.ISubscribe|null} [subscribe] ClientCommand subscribe
         * @property {pricestream.IUnsubscribe|null} [unsubscribe] ClientCommand unsubscribe
         * @property {pricestream.ISubscribeAll|null} [subscribeAll] ClientCommand subscribeAll
         */

        /**
         * Constructs a new ClientCommand.
         * @memberof pricestream
         * @classdesc Represents a ClientCommand.
         * @implements IClientCommand
         * @constructor
         * @param {pricestream.IClientCommand=} [properties] Properties to set
         */
        function ClientCommand(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ClientCommand subscribe.
         * @member {pricestream.ISubscribe|null|undefined} subscribe
         * @memberof pricestream.ClientCommand
         * @instance
         */
        ClientCommand.prototype.subscribe = null;

        /**
         * ClientCommand unsubscribe.
         * @member {pricestream.IUnsubscribe|null|undefined} unsubscribe
         * @memberof pricestream.ClientCommand
         * @instance
         */
        ClientCommand.prototype.unsubscribe = null;

        /**
         * ClientCommand subscribeAll.
         * @member {pricestream.ISubscribeAll|null|undefined} subscribeAll
         * @memberof pricestream.ClientCommand
         * @instance
         */
        ClientCommand.prototype.subscribeAll = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * ClientCommand command.
         * @member {"subscribe"|"unsubscribe"|"subscribeAll"|undefined} command
         * @memberof pricestream.ClientCommand
         * @instance
         */
        Object.defineProperty(ClientCommand.prototype, "command", {
            get: $util.oneOfGetter($oneOfFields = ["subscribe", "unsubscribe", "subscribeAll"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ClientCommand instance using the specified properties.
         * @function create
         * @memberof pricestream.ClientCommand
         * @static
         * @param {pricestream.IClientCommand=} [properties] Properties to set
         * @returns {pricestream.ClientCommand} ClientCommand instance
         */
        ClientCommand.create = function create(properties) {
            return new ClientCommand(properties);
        };

        /**
         * Encodes the specified ClientCommand message. Does not implicitly {@link pricestream.ClientCommand.verify|verify} messages.
         * @function encode
         * @memberof pricestream.ClientCommand
         * @static
         * @param {pricestream.IClientCommand} message ClientCommand message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientCommand.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.subscribe != null && Object.hasOwnProperty.call(message, "subscribe"))
                $root.pricestream.Subscribe.encode(message.subscribe, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.unsubscribe != null && Object.hasOwnProperty.call(message, "unsubscribe"))
                $root.pricestream.Unsubscribe.encode(message.unsubscribe, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.subscribeAll != null && Object.hasOwnProperty.call(message, "subscribeAll"))
                $root.pricestream.SubscribeAll.encode(message.subscribeAll, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ClientCommand message, length delimited. Does not implicitly {@link pricestream.ClientCommand.verify|verify} messages.
         * @function encodeDelimited
         * @memberof pricestream.ClientCommand
         * @static
         * @param {pricestream.IClientCommand} message ClientCommand message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientCommand.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ClientCommand message from the specified reader or buffer.
         * @function decode
         * @memberof pricestream.ClientCommand
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {pricestream.ClientCommand} ClientCommand
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientCommand.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.pricestream.ClientCommand();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.subscribe = $root.pricestream.Subscribe.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.unsubscribe = $root.pricestream.Unsubscribe.decode(reader, reader.uint32());
                        break;
                    }
                case 3: {
                        message.subscribeAll = $root.pricestream.SubscribeAll.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ClientCommand message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof pricestream.ClientCommand
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {pricestream.ClientCommand} ClientCommand
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientCommand.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ClientCommand message.
         * @function verify
         * @memberof pricestream.ClientCommand
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ClientCommand.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.subscribe != null && message.hasOwnProperty("subscribe")) {
                properties.command = 1;
                {
                    let error = $root.pricestream.Subscribe.verify(message.subscribe);
                    if (error)
                        return "subscribe." + error;
                }
            }
            if (message.unsubscribe != null && message.hasOwnProperty("unsubscribe")) {
                if (properties.command === 1)
                    return "command: multiple values";
                properties.command = 1;
                {
                    let error = $root.pricestream.Unsubscribe.verify(message.unsubscribe);
                    if (error)
                        return "unsubscribe." + error;
                }
            }
            if (message.subscribeAll != null && message.hasOwnProperty("subscribeAll")) {
                if (properties.command === 1)
                    return "command: multiple values";
                properties.command = 1;
                {
                    let error = $root.pricestream.SubscribeAll.verify(message.subscribeAll);
                    if (error)
                        return "subscribeAll." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ClientCommand message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pricestream.ClientCommand
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pricestream.ClientCommand} ClientCommand
         */
        ClientCommand.fromObject = function fromObject(object) {
            if (object instanceof $root.pricestream.ClientCommand)
                return object;
            let message = new $root.pricestream.ClientCommand();
            if (object.subscribe != null) {
                if (typeof object.subscribe !== "object")
                    throw TypeError(".pricestream.ClientCommand.subscribe: object expected");
                message.subscribe = $root.pricestream.Subscribe.fromObject(object.subscribe);
            }
            if (object.unsubscribe != null) {
                if (typeof object.unsubscribe !== "object")
                    throw TypeError(".pricestream.ClientCommand.unsubscribe: object expected");
                message.unsubscribe = $root.pricestream.Unsubscribe.fromObject(object.unsubscribe);
            }
            if (object.subscribeAll != null) {
                if (typeof object.subscribeAll !== "object")
                    throw TypeError(".pricestream.ClientCommand.subscribeAll: object expected");
                message.subscribeAll = $root.pricestream.SubscribeAll.fromObject(object.subscribeAll);
            }
            return message;
        };

        /**
         * Creates a plain object from a ClientCommand message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pricestream.ClientCommand
         * @static
         * @param {pricestream.ClientCommand} message ClientCommand
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ClientCommand.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.subscribe != null && message.hasOwnProperty("subscribe")) {
                object.subscribe = $root.pricestream.Subscribe.toObject(message.subscribe, options);
                if (options.oneofs)
                    object.command = "subscribe";
            }
            if (message.unsubscribe != null && message.hasOwnProperty("unsubscribe")) {
                object.unsubscribe = $root.pricestream.Unsubscribe.toObject(message.unsubscribe, options);
                if (options.oneofs)
                    object.command = "unsubscribe";
            }
            if (message.subscribeAll != null && message.hasOwnProperty("subscribeAll")) {
                object.subscribeAll = $root.pricestream.SubscribeAll.toObject(message.subscribeAll, options);
                if (options.oneofs)
                    object.command = "subscribeAll";
            }
            return object;
        };

        /**
         * Converts this ClientCommand to JSON.
         * @function toJSON
         * @memberof pricestream.ClientCommand
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ClientCommand.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ClientCommand
         * @function getTypeUrl
         * @memberof pricestream.ClientCommand
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ClientCommand.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/pricestream.ClientCommand";
        };

        return ClientCommand;
    })();

    pricestream.Subscribe = (function() {

        /**
         * Properties of a Subscribe.
         * @memberof pricestream
         * @interface ISubscribe
         * @property {Array.<string>|null} [gameIds] Subscribe gameIds
         * @property {Array.<string>|null} [leagueIds] Subscribe leagueIds
         * @property {boolean|null} [replace] Subscribe replace
         * @property {Array.<string>|null} [sportIds] Subscribe sportIds
         */

        /**
         * Constructs a new Subscribe.
         * @memberof pricestream
         * @classdesc Represents a Subscribe.
         * @implements ISubscribe
         * @constructor
         * @param {pricestream.ISubscribe=} [properties] Properties to set
         */
        function Subscribe(properties) {
            this.gameIds = [];
            this.leagueIds = [];
            this.sportIds = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Subscribe gameIds.
         * @member {Array.<string>} gameIds
         * @memberof pricestream.Subscribe
         * @instance
         */
        Subscribe.prototype.gameIds = $util.emptyArray;

        /**
         * Subscribe leagueIds.
         * @member {Array.<string>} leagueIds
         * @memberof pricestream.Subscribe
         * @instance
         */
        Subscribe.prototype.leagueIds = $util.emptyArray;

        /**
         * Subscribe replace.
         * @member {boolean} replace
         * @memberof pricestream.Subscribe
         * @instance
         */
        Subscribe.prototype.replace = false;

        /**
         * Subscribe sportIds.
         * @member {Array.<string>} sportIds
         * @memberof pricestream.Subscribe
         * @instance
         */
        Subscribe.prototype.sportIds = $util.emptyArray;

        /**
         * Creates a new Subscribe instance using the specified properties.
         * @function create
         * @memberof pricestream.Subscribe
         * @static
         * @param {pricestream.ISubscribe=} [properties] Properties to set
         * @returns {pricestream.Subscribe} Subscribe instance
         */
        Subscribe.create = function create(properties) {
            return new Subscribe(properties);
        };

        /**
         * Encodes the specified Subscribe message. Does not implicitly {@link pricestream.Subscribe.verify|verify} messages.
         * @function encode
         * @memberof pricestream.Subscribe
         * @static
         * @param {pricestream.ISubscribe} message Subscribe message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Subscribe.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.gameIds != null && message.gameIds.length)
                for (let i = 0; i < message.gameIds.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.gameIds[i]);
            if (message.leagueIds != null && message.leagueIds.length)
                for (let i = 0; i < message.leagueIds.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.leagueIds[i]);
            if (message.replace != null && Object.hasOwnProperty.call(message, "replace"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.replace);
            if (message.sportIds != null && message.sportIds.length)
                for (let i = 0; i < message.sportIds.length; ++i)
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.sportIds[i]);
            return writer;
        };

        /**
         * Encodes the specified Subscribe message, length delimited. Does not implicitly {@link pricestream.Subscribe.verify|verify} messages.
         * @function encodeDelimited
         * @memberof pricestream.Subscribe
         * @static
         * @param {pricestream.ISubscribe} message Subscribe message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Subscribe.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Subscribe message from the specified reader or buffer.
         * @function decode
         * @memberof pricestream.Subscribe
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {pricestream.Subscribe} Subscribe
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Subscribe.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.pricestream.Subscribe();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.gameIds && message.gameIds.length))
                            message.gameIds = [];
                        message.gameIds.push(reader.string());
                        break;
                    }
                case 2: {
                        if (!(message.leagueIds && message.leagueIds.length))
                            message.leagueIds = [];
                        message.leagueIds.push(reader.string());
                        break;
                    }
                case 3: {
                        message.replace = reader.bool();
                        break;
                    }
                case 4: {
                        if (!(message.sportIds && message.sportIds.length))
                            message.sportIds = [];
                        message.sportIds.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Subscribe message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof pricestream.Subscribe
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {pricestream.Subscribe} Subscribe
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Subscribe.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Subscribe message.
         * @function verify
         * @memberof pricestream.Subscribe
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Subscribe.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.gameIds != null && message.hasOwnProperty("gameIds")) {
                if (!Array.isArray(message.gameIds))
                    return "gameIds: array expected";
                for (let i = 0; i < message.gameIds.length; ++i)
                    if (!$util.isString(message.gameIds[i]))
                        return "gameIds: string[] expected";
            }
            if (message.leagueIds != null && message.hasOwnProperty("leagueIds")) {
                if (!Array.isArray(message.leagueIds))
                    return "leagueIds: array expected";
                for (let i = 0; i < message.leagueIds.length; ++i)
                    if (!$util.isString(message.leagueIds[i]))
                        return "leagueIds: string[] expected";
            }
            if (message.replace != null && message.hasOwnProperty("replace"))
                if (typeof message.replace !== "boolean")
                    return "replace: boolean expected";
            if (message.sportIds != null && message.hasOwnProperty("sportIds")) {
                if (!Array.isArray(message.sportIds))
                    return "sportIds: array expected";
                for (let i = 0; i < message.sportIds.length; ++i)
                    if (!$util.isString(message.sportIds[i]))
                        return "sportIds: string[] expected";
            }
            return null;
        };

        /**
         * Creates a Subscribe message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pricestream.Subscribe
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pricestream.Subscribe} Subscribe
         */
        Subscribe.fromObject = function fromObject(object) {
            if (object instanceof $root.pricestream.Subscribe)
                return object;
            let message = new $root.pricestream.Subscribe();
            if (object.gameIds) {
                if (!Array.isArray(object.gameIds))
                    throw TypeError(".pricestream.Subscribe.gameIds: array expected");
                message.gameIds = [];
                for (let i = 0; i < object.gameIds.length; ++i)
                    message.gameIds[i] = String(object.gameIds[i]);
            }
            if (object.leagueIds) {
                if (!Array.isArray(object.leagueIds))
                    throw TypeError(".pricestream.Subscribe.leagueIds: array expected");
                message.leagueIds = [];
                for (let i = 0; i < object.leagueIds.length; ++i)
                    message.leagueIds[i] = String(object.leagueIds[i]);
            }
            if (object.replace != null)
                message.replace = Boolean(object.replace);
            if (object.sportIds) {
                if (!Array.isArray(object.sportIds))
                    throw TypeError(".pricestream.Subscribe.sportIds: array expected");
                message.sportIds = [];
                for (let i = 0; i < object.sportIds.length; ++i)
                    message.sportIds[i] = String(object.sportIds[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a Subscribe message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pricestream.Subscribe
         * @static
         * @param {pricestream.Subscribe} message Subscribe
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Subscribe.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.gameIds = [];
                object.leagueIds = [];
                object.sportIds = [];
            }
            if (options.defaults)
                object.replace = false;
            if (message.gameIds && message.gameIds.length) {
                object.gameIds = [];
                for (let j = 0; j < message.gameIds.length; ++j)
                    object.gameIds[j] = message.gameIds[j];
            }
            if (message.leagueIds && message.leagueIds.length) {
                object.leagueIds = [];
                for (let j = 0; j < message.leagueIds.length; ++j)
                    object.leagueIds[j] = message.leagueIds[j];
            }
            if (message.replace != null && message.hasOwnProperty("replace"))
                object.replace = message.replace;
            if (message.sportIds && message.sportIds.length) {
                object.sportIds = [];
                for (let j = 0; j < message.sportIds.length; ++j)
                    object.sportIds[j] = message.sportIds[j];
            }
            return object;
        };

        /**
         * Converts this Subscribe to JSON.
         * @function toJSON
         * @memberof pricestream.Subscribe
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Subscribe.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Subscribe
         * @function getTypeUrl
         * @memberof pricestream.Subscribe
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Subscribe.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/pricestream.Subscribe";
        };

        return Subscribe;
    })();

    pricestream.Unsubscribe = (function() {

        /**
         * Properties of an Unsubscribe.
         * @memberof pricestream
         * @interface IUnsubscribe
         * @property {Array.<string>|null} [gameIds] Unsubscribe gameIds
         * @property {Array.<string>|null} [leagueIds] Unsubscribe leagueIds
         * @property {Array.<string>|null} [sportIds] Unsubscribe sportIds
         */

        /**
         * Constructs a new Unsubscribe.
         * @memberof pricestream
         * @classdesc Represents an Unsubscribe.
         * @implements IUnsubscribe
         * @constructor
         * @param {pricestream.IUnsubscribe=} [properties] Properties to set
         */
        function Unsubscribe(properties) {
            this.gameIds = [];
            this.leagueIds = [];
            this.sportIds = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Unsubscribe gameIds.
         * @member {Array.<string>} gameIds
         * @memberof pricestream.Unsubscribe
         * @instance
         */
        Unsubscribe.prototype.gameIds = $util.emptyArray;

        /**
         * Unsubscribe leagueIds.
         * @member {Array.<string>} leagueIds
         * @memberof pricestream.Unsubscribe
         * @instance
         */
        Unsubscribe.prototype.leagueIds = $util.emptyArray;

        /**
         * Unsubscribe sportIds.
         * @member {Array.<string>} sportIds
         * @memberof pricestream.Unsubscribe
         * @instance
         */
        Unsubscribe.prototype.sportIds = $util.emptyArray;

        /**
         * Creates a new Unsubscribe instance using the specified properties.
         * @function create
         * @memberof pricestream.Unsubscribe
         * @static
         * @param {pricestream.IUnsubscribe=} [properties] Properties to set
         * @returns {pricestream.Unsubscribe} Unsubscribe instance
         */
        Unsubscribe.create = function create(properties) {
            return new Unsubscribe(properties);
        };

        /**
         * Encodes the specified Unsubscribe message. Does not implicitly {@link pricestream.Unsubscribe.verify|verify} messages.
         * @function encode
         * @memberof pricestream.Unsubscribe
         * @static
         * @param {pricestream.IUnsubscribe} message Unsubscribe message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Unsubscribe.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.gameIds != null && message.gameIds.length)
                for (let i = 0; i < message.gameIds.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.gameIds[i]);
            if (message.leagueIds != null && message.leagueIds.length)
                for (let i = 0; i < message.leagueIds.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.leagueIds[i]);
            if (message.sportIds != null && message.sportIds.length)
                for (let i = 0; i < message.sportIds.length; ++i)
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.sportIds[i]);
            return writer;
        };

        /**
         * Encodes the specified Unsubscribe message, length delimited. Does not implicitly {@link pricestream.Unsubscribe.verify|verify} messages.
         * @function encodeDelimited
         * @memberof pricestream.Unsubscribe
         * @static
         * @param {pricestream.IUnsubscribe} message Unsubscribe message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Unsubscribe.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Unsubscribe message from the specified reader or buffer.
         * @function decode
         * @memberof pricestream.Unsubscribe
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {pricestream.Unsubscribe} Unsubscribe
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Unsubscribe.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.pricestream.Unsubscribe();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.gameIds && message.gameIds.length))
                            message.gameIds = [];
                        message.gameIds.push(reader.string());
                        break;
                    }
                case 2: {
                        if (!(message.leagueIds && message.leagueIds.length))
                            message.leagueIds = [];
                        message.leagueIds.push(reader.string());
                        break;
                    }
                case 3: {
                        if (!(message.sportIds && message.sportIds.length))
                            message.sportIds = [];
                        message.sportIds.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Unsubscribe message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof pricestream.Unsubscribe
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {pricestream.Unsubscribe} Unsubscribe
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Unsubscribe.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Unsubscribe message.
         * @function verify
         * @memberof pricestream.Unsubscribe
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Unsubscribe.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.gameIds != null && message.hasOwnProperty("gameIds")) {
                if (!Array.isArray(message.gameIds))
                    return "gameIds: array expected";
                for (let i = 0; i < message.gameIds.length; ++i)
                    if (!$util.isString(message.gameIds[i]))
                        return "gameIds: string[] expected";
            }
            if (message.leagueIds != null && message.hasOwnProperty("leagueIds")) {
                if (!Array.isArray(message.leagueIds))
                    return "leagueIds: array expected";
                for (let i = 0; i < message.leagueIds.length; ++i)
                    if (!$util.isString(message.leagueIds[i]))
                        return "leagueIds: string[] expected";
            }
            if (message.sportIds != null && message.hasOwnProperty("sportIds")) {
                if (!Array.isArray(message.sportIds))
                    return "sportIds: array expected";
                for (let i = 0; i < message.sportIds.length; ++i)
                    if (!$util.isString(message.sportIds[i]))
                        return "sportIds: string[] expected";
            }
            return null;
        };

        /**
         * Creates an Unsubscribe message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pricestream.Unsubscribe
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pricestream.Unsubscribe} Unsubscribe
         */
        Unsubscribe.fromObject = function fromObject(object) {
            if (object instanceof $root.pricestream.Unsubscribe)
                return object;
            let message = new $root.pricestream.Unsubscribe();
            if (object.gameIds) {
                if (!Array.isArray(object.gameIds))
                    throw TypeError(".pricestream.Unsubscribe.gameIds: array expected");
                message.gameIds = [];
                for (let i = 0; i < object.gameIds.length; ++i)
                    message.gameIds[i] = String(object.gameIds[i]);
            }
            if (object.leagueIds) {
                if (!Array.isArray(object.leagueIds))
                    throw TypeError(".pricestream.Unsubscribe.leagueIds: array expected");
                message.leagueIds = [];
                for (let i = 0; i < object.leagueIds.length; ++i)
                    message.leagueIds[i] = String(object.leagueIds[i]);
            }
            if (object.sportIds) {
                if (!Array.isArray(object.sportIds))
                    throw TypeError(".pricestream.Unsubscribe.sportIds: array expected");
                message.sportIds = [];
                for (let i = 0; i < object.sportIds.length; ++i)
                    message.sportIds[i] = String(object.sportIds[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from an Unsubscribe message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pricestream.Unsubscribe
         * @static
         * @param {pricestream.Unsubscribe} message Unsubscribe
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Unsubscribe.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.gameIds = [];
                object.leagueIds = [];
                object.sportIds = [];
            }
            if (message.gameIds && message.gameIds.length) {
                object.gameIds = [];
                for (let j = 0; j < message.gameIds.length; ++j)
                    object.gameIds[j] = message.gameIds[j];
            }
            if (message.leagueIds && message.leagueIds.length) {
                object.leagueIds = [];
                for (let j = 0; j < message.leagueIds.length; ++j)
                    object.leagueIds[j] = message.leagueIds[j];
            }
            if (message.sportIds && message.sportIds.length) {
                object.sportIds = [];
                for (let j = 0; j < message.sportIds.length; ++j)
                    object.sportIds[j] = message.sportIds[j];
            }
            return object;
        };

        /**
         * Converts this Unsubscribe to JSON.
         * @function toJSON
         * @memberof pricestream.Unsubscribe
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Unsubscribe.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Unsubscribe
         * @function getTypeUrl
         * @memberof pricestream.Unsubscribe
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Unsubscribe.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/pricestream.Unsubscribe";
        };

        return Unsubscribe;
    })();

    pricestream.SubscribeAll = (function() {

        /**
         * Properties of a SubscribeAll.
         * @memberof pricestream
         * @interface ISubscribeAll
         */

        /**
         * Constructs a new SubscribeAll.
         * @memberof pricestream
         * @classdesc Represents a SubscribeAll.
         * @implements ISubscribeAll
         * @constructor
         * @param {pricestream.ISubscribeAll=} [properties] Properties to set
         */
        function SubscribeAll(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new SubscribeAll instance using the specified properties.
         * @function create
         * @memberof pricestream.SubscribeAll
         * @static
         * @param {pricestream.ISubscribeAll=} [properties] Properties to set
         * @returns {pricestream.SubscribeAll} SubscribeAll instance
         */
        SubscribeAll.create = function create(properties) {
            return new SubscribeAll(properties);
        };

        /**
         * Encodes the specified SubscribeAll message. Does not implicitly {@link pricestream.SubscribeAll.verify|verify} messages.
         * @function encode
         * @memberof pricestream.SubscribeAll
         * @static
         * @param {pricestream.ISubscribeAll} message SubscribeAll message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SubscribeAll.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified SubscribeAll message, length delimited. Does not implicitly {@link pricestream.SubscribeAll.verify|verify} messages.
         * @function encodeDelimited
         * @memberof pricestream.SubscribeAll
         * @static
         * @param {pricestream.ISubscribeAll} message SubscribeAll message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SubscribeAll.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SubscribeAll message from the specified reader or buffer.
         * @function decode
         * @memberof pricestream.SubscribeAll
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {pricestream.SubscribeAll} SubscribeAll
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SubscribeAll.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.pricestream.SubscribeAll();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SubscribeAll message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof pricestream.SubscribeAll
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {pricestream.SubscribeAll} SubscribeAll
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SubscribeAll.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SubscribeAll message.
         * @function verify
         * @memberof pricestream.SubscribeAll
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SubscribeAll.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a SubscribeAll message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pricestream.SubscribeAll
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pricestream.SubscribeAll} SubscribeAll
         */
        SubscribeAll.fromObject = function fromObject(object) {
            if (object instanceof $root.pricestream.SubscribeAll)
                return object;
            return new $root.pricestream.SubscribeAll();
        };

        /**
         * Creates a plain object from a SubscribeAll message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pricestream.SubscribeAll
         * @static
         * @param {pricestream.SubscribeAll} message SubscribeAll
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SubscribeAll.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this SubscribeAll to JSON.
         * @function toJSON
         * @memberof pricestream.SubscribeAll
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SubscribeAll.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SubscribeAll
         * @function getTypeUrl
         * @memberof pricestream.SubscribeAll
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SubscribeAll.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/pricestream.SubscribeAll";
        };

        return SubscribeAll;
    })();

    return pricestream;
})();

export { $root as default };
